import React, { useEffect } from 'react';
import { createPortal } from 'react-dom';
import { getBtnData, deleteData, getOneItemColleciton, logStockUsage, registerDailyStockMovement } from '../../api/Api.js';
import { issueAutoNfce } from '../../services/fiscalService';
import { db } from '../../config-firebase/firebase.js';
import PaymentMethod from '../Payment/PaymentMethod';
import { fetchInDataChanges } from '../../api/Api.js';
import { getFirestore, collection, doc, getDoc, runTransaction, query, where, getDocs } from 'firebase/firestore';
import { setDoc, addDoc, updateDoc } from '../../api/FirestoreInterceptor';
import style from '../../assets/styles/RequestListToBePrepared.module.scss';
import { Link } from 'react-router-dom';
import Title from '../title.js';
import { UpdateMenuMessage } from '../Messages/UpdateMenuMessage';
import {
  getFirstFourLetters,
  requestSorter,
  firstNameClient,
  isOrderFullyFinished,
} from '../../Helpers/Helpers.js';
import RecipeModal from './RecipeModal';
import DishRefusalModal from './DishRefusalModal';

import DefaultComumMessage from '../Messages/DefaultComumMessage';
import { GlobalContext } from '../../GlobalContext';
import { useNavigate } from 'react-router-dom';
import ButtonCustomerProfile from '../Promotions/ButtonCustomerProfile';
import MessagePromotions from '../Promotions/MessagePromotions';
import {
  alertMinimunAmount,
  checkUnavaiableRawMaterial,
} from '../../Helpers/Helpers';
import {
  playNewOrderAlert,
  playWaiterCallAlert,
  playPaymentCallAlert,
  playStatusChangeAlert,
} from '../../Helpers/soundAlerts.js';
import { getAnonymousUser } from '../../Hooks/useEnsureAnonymousUser.js';

//import { getOneItemColleciton } from '../../api/Api';

const RequestListToBePrepared = ({ title, statusByUrl }) => {
  const [loadingAvailableMenuDishes, setLoadingAvailableMenuDishes] =
    React.useState(false);
  const [ShowDefaultMessage, setShowDefaultMessage] = React.useState(false);
  const [requestsDoneList, setRequestDoneList] = React.useState([]);
  const [selectedRequestId, setSelectedRequestId] = React.useState(null);
  const [colorStatusRequest, setColorStatusRequest] = React.useState('red');
  const [refusalModalData, setRefusalModalData] = React.useState(null);

  const global = React.useContext(GlobalContext);

  const canCancelOrders = React.useMemo(() => {
    // 1. Super Admin tem permissão total
    const role = localStorage.getItem('currentUserRole') || global?.currentUser?.role;
    if (role === 'admin_TOTAL') return true;

    // 2. Permissões salvas no localStorage
    try {
      const permsRaw = localStorage.getItem('currentUserPermissions');
      if (permsRaw) {
        const perms = JSON.parse(permsRaw);
        if (
          Array.isArray(perms) &&
          (perms.includes('cancelOrder') ||
           perms.includes('cancel_orders') ||
           perms.includes('cancelar pedidos') ||
           perms.includes('ALL'))
        ) {
          return true;
        }
      }
    } catch (e) {
      console.error('Erro ao ler permissões do localStorage:', e);
    }

    // 3. Permissões no objeto global.currentUser
    if (global?.currentUser) {
      if (global.currentUser.role === 'admin_TOTAL') return true;
      const perms = global.currentUser.permissions;
      if (
        Array.isArray(perms) &&
        (perms.includes('cancelOrder') ||
         perms.includes('cancel_orders') ||
         perms.includes('cancelar pedidos') ||
         perms.includes('ALL'))
      ) {
        return true;
      }
    }

    return false;
  }, [global?.currentUser]);

  const navigate = useNavigate();
  const [recipeModal, setRecipeModal] = React.useState({
    openModal: false,
    id: '',
  });

  // const { isOpen, toggle } = useModal();

  const [categories, setCategories] = React.useState([]);
  const [promotions, setPromotions] = React.useState([]);
  const [selectedPromotion, setSelectedPromotion] = React.useState('');
  const [activePromoIndex, setActivePromoIndex] = React.useState(null);
  const [registeredUserIds, setRegisteredUserIds] = React.useState(new Set());
  const [usersMap, setUsersMap] = React.useState(new Map());
  const [benefitedClient, setBenefitedClient] = React.useState([]);
  const [messagePromotionPopup, setMessagePromotionPopup] =
    React.useState(false);
  const [textPromotion, setTextPromotion] = React.useState('');
  const [AddPromotion, setAddPromotion] = React.useState(false);
  const [benefitedClientEdited, setBenefitedClientEdited] = React.useState({});
  const [operation, setOperation] = React.useState('');
  const [currentDiscount, setCurrentDiscount] = React.useState(0);
  const [currentRequest, setCurrentRequest] = React.useState(null);
  const [sideDishesList, setSideDishesList] = React.useState([]);
  const [openRequests, setOpenRequests] = React.useState({});
  const [selectedTableFilter, setSelectedTableFilter] = React.useState(null);

  const [showFinalizarMessage, setShowFinalizarMessage] = React.useState(false);
  const [selectedItemToFinalize, setSelectedItemToFinalize] = React.useState(null);

  const [showPaymentBlockedPopup, setShowPaymentBlockedPopup] = React.useState(false);
  const [selectedItemToPay, setSelectedItemToPay] = React.useState(null);
  const [payingOrders, setPayingOrders] = React.useState({});

  // NOVO: Estado para armazenar os chamados do garçom pendentes
  const [pendingWaiterCalls, setPendingWaiterCalls] = React.useState([]);
  const [pendingPaymentCalls, setPendingPaymentCalls] = React.useState([]);
  const [inspectedCalls, setInspectedCalls] = React.useState(new Set());
  const [inspectedPaymentCalls, setInspectedPaymentCalls] = React.useState(new Set());
  const inspectedCallsRef = React.useRef(new Set());
  const inspectedPaymentCallsRef = React.useRef(new Set());

  // Checkbox de warning: por padrão ativo (true). Se desmarcado, apenas suprime os popups na tela.
  const [warningsEnabled, setWarningsEnabled] = React.useState(() => {
    const saved = localStorage.getItem('pdvWarningsEnabled');
    return saved !== null ? saved === 'true' : true;
  });

  const warningsEnabledRef = React.useRef(warningsEnabled);
  React.useEffect(() => {
    warningsEnabledRef.current = warningsEnabled;
  }, [warningsEnabled]);

  const handleToggleWarnings = (checked) => {
    setWarningsEnabled(checked);
    localStorage.setItem('pdvWarningsEnabled', String(checked));
  };

  const dismissWaiterCall = async (id) => {
    try {
      inspectedCallsRef.current.delete(id);
      setInspectedCalls((prev) => {
        const next = new Set(prev);
        next.delete(id);
        return next;
      });
      await updateDoc(doc(db, 'requests', id), {
        'waiterCall.active': false,
        'waiterCall.popupDismissed': false,
        'waiterCall.checked': true,
        'waiterCall.checkedAt': Date.now(),
      });
    } catch (e) {
      console.error('Erro ao concluir chamado do garçom:', e);
    }
  };

  const dismissPaymentCall = async (id) => {
    try {
      inspectedPaymentCallsRef.current.delete(id);
      setInspectedPaymentCalls((prev) => {
        const next = new Set(prev);
        next.delete(id);
        return next;
      });
      setPendingPaymentCalls((prev) => prev.filter((p) => p.id !== id));
      await updateDoc(doc(db, 'requests', id), {
        'paymentCall.active': false,
      });
    } catch (e) {
      console.error('Erro ao concluir chamado de conta:', e);
    }
  };

  // Rastreamento para alertas sonoros no PDV
  const isInitialSnapshotRef = React.useRef(true);
  const prevOrdersSnapshotRef = React.useRef(new Map());
  const prevWaiterCallIdsRef = React.useRef(new Set());
  const prevPaymentCallIdsRef = React.useRef(new Set());

  const getOrderStateSignature = (order) => {
    const itemsSignature = (order.request || [])
      .map(
        (dish, i) =>
          `${i}_${dish.name || dish.id}_pronto:${Boolean(dish.pronto)}_entregue:${Boolean(dish.entregue)}_deliv:${Boolean(dish.deliveredByWaiter)}`
      )
      .join('|');

    return {
      paymentDone: Boolean(order.paymentDone),
      done: Boolean(order.done),
      orderDelivered: Boolean(order.orderDelivered),
      itemsSignature,
    };
  };

  const openFinalizarModal = (item) => {
    setShowFinalizarMessage(true);
    setSelectedItemToFinalize(item);
  };

  const closeFinalizarModal = () => {
    setShowFinalizarMessage(false);
    setSelectedItemToFinalize(null);
  };

  const confirmFinalizarPedido = async () => {
    const itemToFinalize = selectedItemToFinalize;
    closeFinalizarModal(); // Fecha o modal imediatamente
    if (itemToFinalize) {
      await orderDelivery(itemToFinalize);
    }
  };

  const getPostpaidButtonState = (item) => {
    if (!item.request || item.request.length === 0) return { label: 'PENDENTE', color: 'red', className: style.pendent };

    const hasToDeliver = item.request.some((req) => req.pronto && !req.entregue);
    const allDelivered = item.request.every((req) => req.pronto && req.entregue);

    if (hasToDeliver) {
      return {
        label: 'NOVA ENTREGA',
        color: '#b45309',
        className: `${style.pendent} ${style.blinkingDeliveryBtn}`,
        inlineStyle: { backgroundColor: '#b45309', color: '#ffffff', fontWeight: 'bold' }
      };
    } else if (allDelivered) {
      return { label: 'PRONTO', color: 'green', className: style.done, inlineStyle: {} };
    } else {
      return { label: 'PENDENTE', color: 'red', className: style.pendent, inlineStyle: {} };
    }
  };

  // isOrderFullyFinished importado de Helpers.js

  const handleWaiterDelivery = async (item) => {
    const currentState = getPostpaidButtonState(item);
    if (currentState.label === 'NOVA ENTREGA') {
      const updatedRequests = item.request.map((req) => {
        if (req.pronto && !req.entregue) {
          return { ...req, entregue: true, deliveredByWaiter: true, status: 'Entregue' };
        }
        return req;
      });
      item.request = updatedRequests;

      const allDelivered = updatedRequests.every((req) => req.pronto && req.entregue);
      if (allDelivered) {
        item.done = false;
      } else {
        item.done = true;
      }

      try {
        await setDoc(doc(db, 'requests', item.id), item);

        if (item.idUser) {
          const userDocRef = doc(db, 'user', item.idUser);
          const userDocSnap = await getDoc(userDocRef);
          if (userDocSnap.exists()) {
            const userData = userDocSnap.data();
            if (userData.request && Array.isArray(userData.request)) {
              const newUserDataRequests = userData.request.map((uReq) => {
                const isParentMatch = !uReq.parentRequestId || uReq.parentRequestId === item.id;
                if (isParentMatch) {
                  const match = updatedRequests.find((r) => 
                    (r.indexInRequest !== undefined && uReq.indexInRequest !== undefined && r.indexInRequest === uReq.indexInRequest) ||
                    (r.name === uReq.name && r.entregue)
                  );
                  if (match) {
                    const statusLabel = match.entregue ? 'Entregue' : (match.pronto ? 'Pronto' : (match.status || uReq.status || ''));
                    return {
                      ...uReq,
                      ...match,
                      entregue: Boolean(match.entregue),
                      deliveredByWaiter: Boolean(match.deliveredByWaiter),
                      pronto: Boolean(match.pronto),
                      status: statusLabel
                    };
                  }
                }
                return uReq;
              });
              await updateDoc(userDocRef, { request: newUserDataRequests });
            }
          }
        }
        console.log('Entregas atualizadas com sucesso');
      } catch (err) {
        console.error("Erro ao atualizar entregas", err);
      }
    }
  };

  //  const [newCustomerPromotion, setNewCustomerPromotion] = React.useState(null);
  //  const [shouldRunEffect, setShouldRunEffect] = React.useState(false);

  React.useEffect(() => {
    const unsubscribe = fetchInDataChanges('requests', (data) => {
      let requestList = data.filter((item) => !item.orderDelivered);
      requestList = requestSorter(requestList);

      setRequestDoneList(requestList);

      // NOVO: Verificar chamados pendentes (popup abre apenas se ainda não foi dispensado pelo garçom)
      const newWaiterCalls = requestList.filter(
        (req) => req.waiterCall && req.waiterCall.active === true && !req.waiterCall.popupDismissed
      );

      // Atualiza os chamados garantindo que novos pedidos sejam adicionados e os fechados saiam da tela
      setPendingWaiterCalls((prevCalls) => {
        const keepCalls = prevCalls.filter(pc => newWaiterCalls.some(nc => nc.id === pc.id));
        const addCalls = newWaiterCalls.filter(nc => !prevCalls.some(pc => pc.id === nc.id));
        return [...keepCalls, ...addCalls];
      });

      // NOVO: Verificar chamados de PAGAMENTO pendentes
      const newPaymentCalls = requestList.filter(
        (req) => req.paymentCall && req.paymentCall.active === true
      );

      setPendingPaymentCalls((prevCalls) => {
        const keepCalls = prevCalls.filter(pc => newPaymentCalls.some(nc => nc.id === pc.id));
        const addCalls = newPaymentCalls.filter(nc => !prevCalls.some(pc => pc.id === nc.id));
        return [...keepCalls, ...addCalls];
      });

      // RASTREAMENTO E ALERTA SONORO NO PDV
      if (isInitialSnapshotRef.current) {
        const initialMap = new Map();
        const initialWaiter = new Set();
        const initialPayment = new Set();

        requestList.forEach((order) => {
          initialMap.set(order.id, getOrderStateSignature(order));
          if (order.waiterCall && order.waiterCall.active === true) {
            initialWaiter.add(order.id);
          }
          if (order.paymentCall && order.paymentCall.active === true) {
            initialPayment.add(order.id);
          }
        });

        prevOrdersSnapshotRef.current = initialMap;
        prevWaiterCallIdsRef.current = initialWaiter;
        prevPaymentCallIdsRef.current = initialPayment;
        isInitialSnapshotRef.current = false;
      } else {
        let hasNewWaiterCall = false;
        let hasNewPaymentCall = false;
        let hasNewOrder = false;
        let hasStatusChange = false;

        const currentWaiterIds = new Set();
        const currentPaymentIds = new Set();
        const nextOrdersMap = new Map();

        requestList.forEach((order) => {
          const currentSig = getOrderStateSignature(order);
          nextOrdersMap.set(order.id, currentSig);

          // 1. Chamado do garçom
          if (order.waiterCall && order.waiterCall.active === true) {
            currentWaiterIds.add(order.id);
            if (!prevWaiterCallIdsRef.current.has(order.id)) {
              hasNewWaiterCall = true;
            }
          }

          // 2. Chamado de pagamento (pedir a conta)
          if (order.paymentCall && order.paymentCall.active === true) {
            currentPaymentIds.add(order.id);
            if (!prevPaymentCallIdsRef.current.has(order.id)) {
              hasNewPaymentCall = true;
            }
          }

          // 3. Novo pedido vs Mudança de status em pedido existente
          if (!prevOrdersSnapshotRef.current.has(order.id)) {
            hasNewOrder = true;
          } else {
            const prevSig = prevOrdersSnapshotRef.current.get(order.id);
            if (
              prevSig.paymentDone !== currentSig.paymentDone ||
              prevSig.done !== currentSig.done ||
              prevSig.itemsSignature !== currentSig.itemsSignature
            ) {
              hasStatusChange = true;
            }
          }
        });

        // Dispara o alerta sonoro conforme a prioridade do evento
        if (warningsEnabledRef.current && hasNewWaiterCall) {
          playWaiterCallAlert();
        } else if (warningsEnabledRef.current && hasNewPaymentCall) {
          playPaymentCallAlert();
        } else if (hasNewOrder) {
          playNewOrderAlert();
        } else if (hasStatusChange) {
          playStatusChangeAlert();
        }

        prevOrdersSnapshotRef.current = nextOrdersMap;
        prevWaiterCallIdsRef.current = currentWaiterIds;
        prevPaymentCallIdsRef.current = currentPaymentIds;
      }
    });

    fetchData(); // NOVO: Garante que as promoções sejam carregadas ao montar o componente
    return () => {
      if (typeof unsubscribe === 'function') {
        unsubscribe();
      }
    };
  }, []);



  // toda vez que a lista mudar, garante que o estado tenha as chaves corretas

  // toda vez que a lista mudar, garante que o estado tenha as chaves corretas
  React.useEffect(() => {
    if (!requestsDoneList) return;
    if (requestsDoneList.length > 0) {
      // Gatilho automático para NFC-e

      const triggerFiscal = async () => {
        /*
        console.log(`[DEBUG NFCe] Analisando fila (${requestsDoneList.length} pedidos). ` +
          `pdvLocal: ${localStorage.getItem('pdv')}, autoNfceContexto: ${global.enableAutoNfce}`);
        */
        for (const order of requestsDoneList) {
          /*
          console.log(`[DEBUG NFCe] Olhando pedido ${order.countRequest} (ID: ${order.id}). ` +
            `paymentDone: ${order.paymentDone}, nfceIssued: ${order.nfceIssued}, sendingNfce: ${order.sendingNfce}`);
          */

          // 1. FILTRO RÁPIDO EM MEMÓRIA (mesmo tab, mesmo ciclo React):
          if (
            order.paymentDone === true &&
            !order.nfceIssued &&
            !order.sendingNfce &&
            !order.nfceStatus &&
            !global.processedOrdersGlobal.current.has(order.id)
          ) {
            // Marca IMEDIATAMENTE na memória para bloquear próximas renderizações
            global.processedOrdersGlobal.current.add(order.id);

            /*
            console.log(
              `[LOCK] Iniciando trava para pedido ${order.countRequest} (ID: ${order.id})`,
            );
            */

            try {
              // 2. TRAVA ATÔMICA NO FIRESTORE (protege contra múltiplas abas/dispositivos):
              // runTransaction lê o documento fresco e só atualiza se ninguém mais travou.
              // Se duas abas tentarem ao mesmo tempo, o Firestore garante que apenas uma vence.
              const orderRef = doc(db, 'requests', order.id);
              const acquired = await runTransaction(db, async (transaction) => {
                const freshDoc = await transaction.get(orderRef);
                if (!freshDoc.exists()) return false;
                const freshData = freshDoc.data();

                // Verifica com dados FRESCOS do servidor (não do snapshot local)
                if (freshData.nfceIssued || freshData.sendingNfce || freshData.nfceStatus) {
                  return false; // Outro processo já travou, emitiu, ou registrou erro/rejeição
                }

                // Trava atômica — ninguém mais pode travar até liberarmos
                transaction.update(orderRef, { sendingNfce: true });
                return true;
              });

              if (!acquired) {
                console.log(
                  `[LOCK] Pedido ${order.countRequest} já está sendo processado por outra instância. Ignorando.`,
                );
                continue; // Próximo pedido no loop
              }

              /*
              console.log(
                `[LOCK] Trava ATÔMICA ativada para ${order.countRequest}. Enviando para API (issueAutoNfce)...`,
              );
              */

              // 3. ENVIA PARA A API (Processo demorado)
              let result;
              try {
                result = await issueAutoNfce(order);
                // console.log(`[DEBUG NFCe] Retorno de issueAutoNfce para ${order.countRequest}:`, result);
              } catch (apiErr) {
                // console.error(`[DEBUG NFCe] EXCEPTION no issueAutoNfce para ${order.countRequest}:`, apiErr);
                throw apiErr; // Lança para o catch de erro geral tratar a trava
              }

              // 4. FINALIZA
              if (
                result &&
                result.status === 'autorizado' &&
                result.caminho_danfe
              ) {
                // SUCESSO: Marca como emitido e solta a trava
                await updateDoc(orderRef, {
                  nfceIssued: true,
                  sendingNfce: false,
                  nfcePrinted: false,
                  caminho_danfe: result.caminho_danfe,
                  nfceStatus: result.status,
                  nfceRef: result.ref,
                });
                console.log(
                  `[SUCESSO] Nota emitida para ${order.countRequest}. Trava liberada.`,
                );
              } else {
                // ERRO NA API: Grava o erro e solta a trava (sem re-emitir automaticamente)
                console.error(
                  `[ERRO API] Falha autorização para ${order.countRequest}. Gravando erro.`,
                  result,
                );
                await updateDoc(orderRef, { 
                  sendingNfce: false,
                  nfceStatus: (result?.status === 'rejeitado') ? 'rejeitado' : 'erro',
                  nfceErrorDetail: result?.mensagem_sefaz || result?.erro || 'Erro na resposta da Focus API'
                });
              }
            } catch (err) {
              // ERRO GERAL (Ex: Falha de rede ao travar)
              console.error(
                `[ERRO GERAL] Falha no processo para ${order.countRequest}:`,
                err,
              );
              try {
                await updateDoc(doc(db, 'requests', order.id), {
                  sendingNfce: false,
                  nfceStatus: 'erro',
                  nfceErrorDetail: err?.message || 'Erro de rede ou conexão com o servidor'
                });
              } catch (unlockErr) {
                console.error('Falha crítica ao destrancar pedido:', unlockErr);
              }
            }
          }
        }
      };

      const autoNfceActive = global.enableAutoNfce;
      const isPdv = localStorage.getItem('pdv') === 'true';

      const shouldTrigger = autoNfceActive && isPdv;

      console.log(`[DEBUG NFCe] Analisando gatilho de emissão: enableAutoNfce=${autoNfceActive}, isPdv=${isPdv}, shouldTrigger=${shouldTrigger}`);

      if (shouldTrigger) {
        triggerFiscal();
      }

      localStorage.removeItem('backorder');
    }

    setOpenRequests((prev) => {
      const next = {};
      requestsDoneList.forEach((item) => {
        // mantém valor antigo se já existia, senão começa fechado
        next[item.id] = prev[item.id] ?? false;
      });
      return next;
    });
  }, [requestsDoneList]);

  // React.useEffect(() => {
  //   if (shouldRunEffect) {
  //     if (newCustomerPromotion !== true) {
  //       if (newCustomerPromotion) {
  //         addBenefitedClientWithNoDescount(benefitedClientEdited, 'add');
  //       } else if (newCustomerPromotion === false) {
  //         addBenefitedClientWithNoDescount(benefitedClientEdited, 'edit');
  //       }
  //       setShouldRunEffect(false); // Resetar para evitar chamadas indesejadas
  //     }
  //   }
  // }, [newCustomerPromotion, shouldRunEffect]);

  // const handleAutomaticFiscalIssuance = (requestsDoneList) => {
  //   if (requestsDoneList.length > 0 && requestsDoneList.paymentDone === true) {

  //   }
  // }

  const fetchUserRequests = async () => {
    let [requestList, usersData] = await Promise.all([
      getBtnData('requests'),
      getBtnData('user'),
    ]);
    requestList = requestList.filter((item) => item.orderDelivered === false);
    requestList = requestSorter(requestList);
    setRequestDoneList(requestList);

    if (Array.isArray(usersData)) {
      const map = new Map();
      usersData.forEach((u) => {
        if (u && u.id) {
          map.set(u.id, u);
        }
      });
      setUsersMap(map);
    }
  };

  const fetchData = async () => {
    try {
      const [promotionsData, benefitedClientData, usersData] = await Promise.all([
        getBtnData('Promotions'),
        getBtnData('BenefitedCustomer'),
        getBtnData('user'),
      ]);

      if (Array.isArray(usersData)) {
        const map = new Map();
        usersData.forEach((u) => {
          if (u && u.id) {
            map.set(u.id, u);
          }
        });
        setUsersMap(map);

        const validIds = new Set(
          usersData
            .filter((u) => u && u.name && u.name !== 'anonimo')
            .map((u) => u.id)
        );
        setRegisteredUserIds(validIds);
      }
      
      const now = new Date();
      const today = new Date(now.getFullYear(), now.getMonth(), now.getDate());

      const promotionsFilter = promotionsData.filter((promotion) => {
        if (!promotion?.startDate || !promotion?.finalDate || 
            typeof promotion.startDate !== 'string' || typeof promotion.finalDate !== 'string') {
          return false;
        }

        try {
          const startParts = promotion.startDate.split('-');
          const finalParts = promotion.finalDate.split('-');
          
          if (startParts.length !== 3 || finalParts.length !== 3) return false;

          const startDate = new Date(
            Number(startParts[0]),
            Number(startParts[1]) - 1,
            Number(startParts[2])
          );
          const finalDate = new Date(
            Number(finalParts[0]),
            Number(finalParts[1]) - 1,
            Number(finalParts[2])
          );

          return today >= startDate && today <= finalDate;
        } catch (e) {
          console.error('Erro ao processar data da promoção:', e);
          return false;
        }
      });

      setPromotions(promotionsFilter);
      setBenefitedClient(benefitedClientData);
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  };

  const handleDeleteRequest = async (id) => {
    if (!canCancelOrders) {
      alert('Você não tem permissão para cancelar pedidos. Consulte o gerente.');
      setShowDefaultMessage(false);
      return;
    }
    try {
      const data = await getOneItemColleciton('requests', id);
      if (data) {
        await deleteData('requests', id);
        if (data.name === 'anonimo' || data.name === 'anonymous') {
          if (data.idUser) {
            const userRef = doc(db, 'user', data.idUser);
            const userSnap = await getDoc(userRef);
            if (userSnap.exists()) {
              await deleteData('user', data.idUser);
            }
          }
        } else if (data.idUser) {
          const userRef = doc(db, 'user', data.idUser);
          const userSnap = await getDoc(userRef);
          if (userSnap.exists()) {
            await updateDoc(userRef, { request: [] });
          } else {
            console.warn(`[WARNING] Documento de usuário ${data.idUser} não existe, pulando limpeza.`);
          }
        }
      }
    } catch (error) {
      console.error('Erro ao deletar/cancelar pedido:', error);
    } finally {
      setShowDefaultMessage(false); // Fecha o modal após excluir
    }
  };

  const openShowModal = (id) => {
    if (!canCancelOrders) {
      alert('Você não tem permissão para cancelar pedidos. Consulte o gerente.');
      return;
    }
    setShowDefaultMessage(true);
    setSelectedRequestId(id);
  };

  const closeModal = () => {
    setShowDefaultMessage(false);
  };

  const RequestDone = async (item) => {
    try {
      await updateDoc(doc(db, 'requests', item.id), { done: false });
      setRequestDoneList((prevList) =>
        prevList.map((req) =>
          req.id === item.id ? { ...req, done: false } : req
        )
      );
      console.log('Document successfully updated !');
    } catch (error) {
      console.error(error);
    }
  };

  const handlePaymentMethodChange = async (method, item) => {
    try {
      await updateDoc(doc(db, 'requests', item.id), {
        paymentMethod: method,
      });
      setRequestDoneList((prevList) =>
        prevList.map((req) =>
          req.id === item.id ? { ...req, paymentMethod: method } : req
        )
      );
      console.log('Payment method updated successfully:', method);
    } catch (error) {
      console.error('Error updating payment method:', error);
    }
  };

  const descontFinalPrice = async (descont, idRequest) => {
    try {
      const requestRef = doc(db, 'requests', idRequest);

      const requestSnap = await getDoc(requestRef);

      if (requestSnap.exists()) {
        // Obtém o valor atual de finalPriceRequest
        const currentFinalPrice = requestSnap.data().finalPriceRequest;

        // Calcula o novo valor subtraindo o desconto
        const updatedFinalPrice = currentFinalPrice - descont;

        // Atualiza o documento no Firestore com o novo valor
        await updateDoc(requestRef, {
          finalPriceRequest: updatedFinalPrice,
        });
        console.log(
          'finalPriceRequest atualizado com sucesso para:',
          updatedFinalPrice,
        );

        // Aqui você pode atualizar o estado local para refletir a mudança imediatamente na interface
        // Exemplo:
        // fetchUserRequests(); // Supondo que setFinalPriceRequest seja um estado
      } else {
        console.log('Documento não encontrado!');
      }
    } catch (error) {
      console.error('Erro ao atualizar finalPriceRequest:', error);
    }
  };

  const unlockPayment = async (item) => {
    if (!item) return;
    try {
      const docRef = doc(db, 'requests', item.id);
      // Simula o chamado de pagamento sendo atendido pelo garçom, desbloqueando o fluxo
      await updateDoc(docRef, {
        'paymentCall.active': false,
        'paymentCall.tableNumber': item.tableNumber || '',
        'paymentCall.callerName': item.name || 'Cliente'
      });
      setShowPaymentBlockedPopup(false);
      setSelectedItemToPay(null);
    } catch (err) {
      console.error("Erro ao desbloquear pagamento:", err);
    }
  };

  const changeStatusPaid = async (item) => {
    if (!item?.id || payingOrders[item.id]) return;

    setPayingOrders((prev) => ({ ...prev, [item.id]: true }));

    try {
      const updates = {
        paymentDone: true,
      };

      // DÉBITO DE CRÉDITO DO CLIENTE (se houver idUser e o cliente tiver saldo de crédito)
      if (item.idUser) {
        try {
          const userRef = doc(db, 'user', item.idUser);
          const userSnap = await getDoc(userRef);
          if (userSnap.exists()) {
            const userData = userSnap.data();
            const currentCredit = parseFloat(userData.credit || 0);
            if (currentCredit > 0) {
              const orderTotal = parseFloat(item.finalPriceRequest || 0);
              const creditUsed = Math.min(currentCredit, orderTotal);
              const creditRemaining = Math.max(0, currentCredit - creditUsed);

              updates.creditUsed = Number(creditUsed.toFixed(2));
              updates.creditRemaining = Number(creditRemaining.toFixed(2));
              updates.previousCredit = Number(currentCredit.toFixed(2));

              await updateDoc(userRef, {
                credit: creditRemaining > 0 ? Number(creditRemaining.toFixed(2)) : 0,
              });

              console.log(
                `[CRÉDITO DEBITADO] Cliente: ${userData.name || 'Cliente'}, Crédito anterior: R$ ${currentCredit.toFixed(2)}, Usado: R$ ${creditUsed.toFixed(2)}, Restante: R$ ${creditRemaining.toFixed(2)}`
              );
            }
          }
        } catch (creditErr) {
          console.error('Erro ao processar débito de crédito do cliente:', creditErr);
        }
      }

      await updateDoc(doc(db, 'requests', item.id), updates);

      setRequestDoneList((prevList) =>
        prevList.map((req) =>
          req.id === item.id ? { ...req, ...updates } : req
        )
      );

      global.setUserNewRequest({ ...item, ...updates });
      console.log('Order status paid successfully updated !');
    } catch (error) {
      console.error('Error updating status paid:', error);
    } finally {
      setPayingOrders((prev) => {
        const next = { ...prev };
        delete next[item.id];
        return next;
      });
    }
  };

  // const displayStatus = (item) => {
  //   if (!item?.paymentDone) return 'Não pago';
  //   if (item?.paymentDone === false && item?.done === true) return 'Não pago';
  //   if (item?.paymentDone === true && item?.done === true) {
  //     return 'Pago';
  //   }
  //   if (item?.paymentDone === true && item?.done === false) {
  //     return 'Feito';
  //   }
  //   return;
  // };
  const getStatusAndColor = (item) => {
    const fullyFinished = isOrderFullyFinished(item);

    // Prioridade para "Nova Entrega" (Itens prontos na cozinha aguardando o garçom levar à mesa)
    const hasToDeliver = item.request && item.request.some((req) => req.pronto && !req.entregue);
    if (hasToDeliver) return { status: 'Nova Entrega', color: '#b45309' };

    if (!item?.paymentDone) return { status: 'Não pago', color: 'red' };
    if (item?.paymentDone === false && item?.done === true)
      return { status: 'Não pago', color: 'red' };
    
    // Se o pagamento foi feito
    if (item?.paymentDone === true) {
      // Se já foi marcado como 'done' OU se todos os itens já estão prontos/entregues
      if (item?.done === false || fullyFinished) {
        return { status: 'Feito', color: 'green' };
      }
      return { status: 'Pago', color: 'yellow' };
    }

    return { status: '', color: 'black' };
  };

  useEffect(() => {
    setColorStatusRequest('red');
  }, [requestsDoneList]);

  const updateIngredientsStock = async (item) => {
    const dateTime = item.dateTime;
    const { request } = item;
    const orderNumber = item.countRequest || '';

    if (request && request.length > 0) {
      await updateSideDihesInStock(request, dateTime, orderNumber);
    }

    for (let i = 0; i < request.length; i++) {
      const currentItem = request[i];

      const account = currentItem.name;
      const FinalingridientsList = currentItem?.recipe?.FinalingridientsList;
      
      console.log(`[STOCK DEBUG] Processing item: ${account}, id: ${currentItem.id}, size: ${currentItem.size}`);
      console.log(`[STOCK DEBUG] FinalingridientsList:`, FinalingridientsList);

      if (!FinalingridientsList) {
        console.warn(`[STOCK DEBUG] No FinalingridientsList for ${account}. recipe object:`, currentItem?.recipe);
        alert(
          'Este produto precisa ter uma receita cadastrada para ser vendido.',
        );
        continue; // ou continue, dependendo do seu fluxo
      }

      const size = currentItem?.size;
      let listBySize = null;

      if (Array.isArray(FinalingridientsList)) {
        listBySize = FinalingridientsList;
        console.log(`[STOCK DEBUG] FinalingridientsList is array. listBySize length: ${listBySize.length}`);
      } else if (typeof FinalingridientsList === 'object') {
        console.log(`[STOCK DEBUG] FinalingridientsList is object.`);
        if (size) {
          if (Array.isArray(FinalingridientsList[size])) {
            listBySize = FinalingridientsList[size];
            console.log(`[STOCK DEBUG] Found list for exact size: ${size}. Length: ${listBySize.length}`);
          } else {
            console.log(`[STOCK DEBUG] Exact size not found. Fetching dish definition for mapping...`);
            try {
              const dishDef = await getOneItemColleciton('item', currentItem.id);
              console.log(`[STOCK DEBUG] dishDef CustomizedPrice:`, dishDef?.CustomizedPrice);
              if (dishDef && dishDef.CustomizedPrice) {
                const mapping = {
                  [dishDef.CustomizedPrice.firstLabel]: 'firstPrice',
                  [dishDef.CustomizedPrice.secondLabel]: 'secondPrice',
                  [dishDef.CustomizedPrice.thirdLabel]: 'thirdPrice',
                };
                const mappedKey = mapping[size];
                console.log(`[STOCK DEBUG] Mapped key for size ${size} is ${mappedKey}`);
                if (mappedKey && Array.isArray(FinalingridientsList[mappedKey])) {
                  listBySize = FinalingridientsList[mappedKey];
                  console.log(`[STOCK DEBUG] Found list using mapped key ${mappedKey}. Length: ${listBySize.length}`);
                }
              }
            } catch (err) {
              console.error(`Erro ao buscar definição do prato ${currentItem.name}:`, err);
            }

            // Fallback difuso caso as labels difiram por espaços ou caixa (ex: "330 ml" vs "330ml")
            if (!listBySize) {
              console.log(`[STOCK DEBUG] Fallback difuso para tamanho: ${size}`);
              const normalizedSize = size.replace(/\s+/g, '').toLowerCase();
              const foundKey = Object.keys(FinalingridientsList).find(k => 
                k.replace(/\s+/g, '').toLowerCase() === normalizedSize
              );
              console.log(`[STOCK DEBUG] Fallback difuso encontrou chave: ${foundKey}`);
              if (foundKey && Array.isArray(FinalingridientsList[foundKey])) {
                listBySize = FinalingridientsList[foundKey];
                console.log(`[STOCK DEBUG] Found list using fallback key ${foundKey}. Length: ${listBySize.length}`);
              }
            }
          }
        } else {
          console.log(`[STOCK DEBUG] Item has no size specified, but recipe is object. Cannot determine ingredients list.`);
        }
      }

      if (Array.isArray(listBySize)) {
        console.log(`[STOCK DEBUG] Proceeding to deduct ${listBySize.length} ingredients for ${account}`);
        for (let j = 0; j < listBySize.length; j++) {
          const ingredient = listBySize[j];
          const currentObj = {
            product: ingredient.name,
            totalVolume: -Number(ingredient.amount.replace(',', '.')),
            unitOfMeasurement: ingredient.unitOfMeasurement || '',
            CostPerUnit: ingredient.portionCost || 0,
            amount: 0,
            totalCost: 0,
            volumePerUnit: 0,
          };
          console.log(`[STOCK DEBUG] Deducting ingredient: ${ingredient.name}, volume: ${currentObj.totalVolume}`);
          await handleStock(currentObj, account, dateTime, orderNumber);
        }
        console.log(`[STOCK DEBUG] Finished deducting ingredients for ${account}`);
      } else {
        console.error(`[STOCK DEBUG] CRITICAL: Não foi possível encontrar a lista de ingredientes para o tamanho "${size}" do prato "${currentItem.name}"! recipe object:`, currentItem?.recipe);
      }
    }
  };

  const updateSideDihesInStock = async (request, dateTime, orderNumber = '') => {
    if (!request || !Array.isArray(request) || request.length === 0) return;

    for (let i = 0; i < request.length; i++) {
      const currentItem = request[i];
      const account = currentItem.name;
      if (
        currentItem.sideDishes &&
        Array.isArray(currentItem.sideDishes) &&
        currentItem.sideDishes.length > 0
      ) {
        for (let j = 0; j < currentItem.sideDishes.length; j++) {
          const sideDish = currentItem.sideDishes[j];
          
          if (sideDish.isBasic) continue; // Pula baixa de estoque se for modo básico (sem vínculo)
          
          const portionVal = sideDish.portionUsed !== undefined ? sideDish.portionUsed : sideDish.portionCost;
          
          const currentObj = {
            product: sideDish.name,
            totalVolume: -parseToNumber(portionVal),
            unitOfMeasurement: sideDish.unit || '',
            CostPerUnit: sideDish.portionCost || 0,
            amount: 0,
            totalCost: 0,
            volumePerUnit: 0,
          };
          await handleStock(currentObj, account, dateTime, orderNumber);
        }
      }
    }
  };

  function parseToNumber(value) {
    if (typeof value === 'string') {
      return Number(value.replace(',', '.'));
    }
    return Number(value);
  }

  function round(value, decimals = 2) {
    return Math.round(value * 10 ** decimals) / 10 ** decimals;
  }

  const handleStock = async (
    itemsStock,
    account = 'Editado',
    paymentDate = null,
    orderNumber = '',
  ) => {
    if (!Array.isArray(itemsStock)) {
      itemsStock = [itemsStock];
    }

    if (!paymentDate) {
      const today = new Date();
      const day = String(today.getDate()).padStart(2, '0');
      const month = String(today.getMonth() + 1).padStart(2, '0'); // Mês é zero-based
      const year = today.getFullYear();
      const hours = String(today.getHours()).padStart(2, '0');
      const minutes = String(today.getMinutes()).padStart(2, '0');
      const seconds = String(today.getSeconds()).padStart(2, '0');
      paymentDate = `${day}/${month}/${year} - ${hours}:${minutes}:${seconds}`;
    }

    for (let i = 0; i < itemsStock.length; i++) {
      let currentItem = itemsStock[i];

      // Busca o documento correspondente pelo nome do produto
      const stockCol = collection(db, 'stock');
      const q = query(stockCol, where('product', '==', currentItem.product));
      const querySnapshot = await getDocs(q);

      if (!querySnapshot.empty) {
        const docSnap = querySnapshot.docs[0];
        const docRef = doc(db, 'stock', docSnap.id);

        try {
          const result = await runTransaction(db, async (transaction) => {
            const freshDoc = await transaction.get(docRef);
            if (!freshDoc.exists()) {
              throw new Error('Stock item not found during transaction');
            }
            const itemFinded = freshDoc.data();
            itemFinded.id = docSnap.id; // Garante o id

            // Executa os cálculos de volume e custo usando dados frescos do servidor
            const previousCost = parseToNumber(itemFinded.totalCost);
            const previousVolume = parseToNumber(itemFinded.totalVolume);
            const cost = account === 'Editado' ? 0 : currentItem.totalCost;
            const pack =
              account === 'Editado'
                ? Number(currentItem.amount)
                : Number(itemFinded.amount) + Number(currentItem.amount);
            const volume = account === 'Editado' ? 0 : currentItem.totalVolume;
            const unit = currentItem.unitOfMeasurement;

            let updatedTotalCost = previousCost;
            let updatedTotalVolume = previousVolume;

            if (
              account !== 'Editado'
            ) {
              const volumeBefore = parseToNumber(currentItem.totalVolume);
              updatedTotalVolume = round(volumeBefore + previousVolume, 4);

              if (updatedTotalVolume <= 0) {
                updatedTotalVolume = 0;
                updatedTotalCost = 0;
              } else if (previousVolume > 0) {
                // Redução proporcional do custo com base no volume restante
                updatedTotalCost = round(previousCost * (updatedTotalVolume / previousVolume), 2);
              } else {
                updatedTotalCost = 0;
              }
            }

            const updatedProduct = {
              ...itemFinded,
              totalCost: updatedTotalCost,
              totalVolume: updatedTotalVolume,
              amount: pack,
            };

            const logEvent = stockHistoryList(
              itemFinded,
              account,
              paymentDate,
              pack,
              cost,
              unit,
              volume,
              previousVolume,
              previousCost,
              updatedTotalCost,
              updatedTotalVolume,
              orderNumber,
            );

            const cleanedProduct = cleanObject(updatedProduct);
            delete cleanedProduct.UsageHistory;
            delete cleanedProduct.id;

            transaction.update(docRef, cleanedProduct);

            return { cleanedProduct, logEvent, itemFinded };
          });

          await logStockUsage(docSnap.id, result.logEvent);
          await updatingStockAndMenu(result.itemFinded, result.cleanedProduct);

        } catch (txError) {
          console.error(`Erro na transação de estoque para ${currentItem.product}:`, txError);
        }

      } else {
        const logEvent = stockHistoryList(
          currentItem,
          account,
          paymentDate,
          0,
          currentItem.totalCost,
          currentItem.totalVolume,
          orderNumber,
        );
        let cleanedItem = cleanObject(currentItem);
        delete cleanedItem.UsageHistory;
        
        const newDocRef = await addDoc(collection(db, 'stock'), cleanedItem);
        await logStockUsage(newDocRef.id, logEvent);
        await updatingStockAndMenu(null, cleanedItem);
      }
    }
  };

  const updatingStockAndMenu = async (itemFinded, currentItem) => {
    // Se o restaurante não opera com controle de estoque, não executa checagens nem dispara avisos
    if (!global.hasRawMaterial) return;

    if (!itemFinded) {
      console.warn(`[STOCK] updatingStockAndMenu ignorado: "${currentItem.product}" não possui registro de estoque correspondente.`);
      return;
    }

    // Sempre atualiza a disponibilidade dos pratos no menu ao alterar o estoque
    setLoadingAvailableMenuDishes(true);
    const res = await checkUnavaiableRawMaterial(itemFinded.id);
    setLoadingAvailableMenuDishes(res);

    // Silencia avisos/alerta se os limites de aviso e indisponibilidade forem zero
    const isZeroThreshold = Number(itemFinded.minimumAmount) === 0 && Number(itemFinded.disabledDish) === 0;

    if (!isZeroThreshold && currentItem.totalVolume < itemFinded.minimumAmount) {
      if (!hasWarningForProduct(currentItem.product)) {
        console.log(`Aviso já registrado para ${currentItem.product}`);
        alert(
          `Volume do item ${currentItem.product} está abaixo do recomendado. Verifique o estoque.`,
        );

        const check = alertMinimunAmount(
          currentItem.product,
          currentItem.totalVolume,
          itemFinded.minimumAmount,
          currentItem.totalCost,
        );

        if (check && check.message) {
          try {
            const key = 'warningAmountMessage';
            let stored = localStorage.getItem(key);
            let warnings = stored ? JSON.parse(stored) : [];
            if (!Array.isArray(warnings)) warnings = [];
            warnings.push(check.message);
            localStorage.setItem(key, JSON.stringify(warnings));
            console.log('O que é esse global aqui  ', global);
            global.setWarningLowRawMaterial((prev) => [...prev, check.message]);
          } catch (err) {
            console.error(
              'Erro ao atualizar warningAmountMessage no localStorage',
              err,
            );
          }
        }
      }
    }
  };

  const hasWarningForProduct = (productName) => {
    const raw = localStorage.getItem('warningAmountMessage');
    let parsed = JSON.parse(raw);
    const res =
      Array.isArray(parsed) &&
      parsed.length > 0 &&
      parsed.some(
        (entry) => typeof entry === 'string' && entry.includes(productName),
      );
    return res;
  };

  const cleanObject = (obj) => {
    if (obj && typeof obj === 'object' && !Array.isArray(obj)) {
      return Object.fromEntries(
        Object.entries(obj)
          .filter(([_, value]) => value !== undefined && value !== null)
          .map(([key, value]) => [key, cleanObject(value)]), // Limpa recursivamente
      );
    }
    return obj; // Retorna o valor se não for objeto
  };

  const stockHistoryList = (
    item,
    account,
    paymentDate,
    pack,
    cost,
    unit,
    volume,
    previousVolume,
    previousCost,
    totalCost,
    totalVolume,
    orderNumber = '',
  ) => {
    const stockEventRegistration = {
      date: paymentDate,
      outputProduct: Number(volume).toFixed(2),
      category: account || 0,
      unit: unit,
      package: pack,
      inputProduct: 0,
      cost: cost,
      previousVolume: previousVolume,
      previousCost: previousCost,
      ContentsInStock: totalVolume,
      totalResourceInvested: Number(totalCost).toFixed(2),
      orderNumber: orderNumber,
    };
    return stockEventRegistration;
  };

  // disparada quando o usuário seleciona uma promoção
  const handleSelectChange = async (e, item) => {
    const isRegistered = registeredUserIds.has(item.idUser);
    const hasPromotionAlready = 
      item.hasAppliedPromotion || 
      item.appliedPromotion || 
      (item.request && item.request.some(r => r.promotional));

    if (!isRegistered) {
      alert('Promoções só podem ser aplicadas a clientes cadastrados!');
      return;
    }

    if (hasPromotionAlready) {
      alert('Uma promoção já foi aplicada a este pedido!');
      return;
    }

    const rawValue = e.target.value;
    if (rawValue === '') return;
    const value = Number(rawValue);
    
    // GATILHO LIMPO: Reseta o select imediatamente para "Promoções" assim que é clicado.
    // Isso garante que o evento onChange dispare sempre no próximo clique.
    setSelectedPromotion(''); 
    setActivePromoIndex(value); // Salva o índice em um estado separado para processamento
    
    setCurrentRequest(item);
    
    const currentPromotion = promotions[value];
    if (!currentPromotion) return; // Segurança extra // Obtém a promoção selecionada
    const { title, reusable, rules, discount, minimumValue, promotionalItemId, promotionalItemName } = currentPromotion; // Extrai os dados da promoção
    setCurrentRequest(item);
    // Objeto para ser enviado pela primeira vez
    const benefitedClientObj = {
      name: item.name,
      idUser: item.idUser,
      promotionTitle: [title],
      dateTime: item.dateTime,
      currentFinalPriceRequest: item.finalPriceRequest,
      benefitUsed: [],
    };
    // benefitedClientObj.benefitUsed.push({
    //   date: item.dateTime,
    //   nomeDaPromocao: title,
    //   discount: currentPromotion.discount,
    //   listaDeProdutos: item.request.map((req) => req.name),
    // });

    // Verifica se o cliente já foi beneficiado
    const benefitedClientFinded = benefitedClient.find(
      (client) => client.idUser === item.idUser,
    );
    // Se o cliente não foi beneficiado
    if (!benefitedClientFinded) {
      // setNewCustomerPromotion(true);Remove
      setMessagePromotionPopup(true); // Abre o modal
      setAddPromotion(true); // Habilita o botão de continuar
      if (minimumValue) {
        acumulativePurchase(item, benefitedClientObj, currentPromotion);
      } else {
        // Validação de disponibilidade do item promocional se houver
        if (promotionalItemId) {
          try {
            const itemPromo = await getOneItemColleciton('item', promotionalItemId);
            if (!itemPromo || itemPromo.display === false) {
              setTextPromotion(`Infelizmente o produto da promoção (${promotionalItemName}) está indisponível no momento.`);
              setAddPromotion(false);
              setMessagePromotionPopup(true);
              setSelectedPromotion('');
              return;
            }
          } catch (error) {
            console.error("Erro ao verificar item da promoção", error);
          }
        }

        const promoMsg = promotionalItemId 
          ? (currentPromotion.isPercentage 
              ? `Você está prestes a resgatar a promoção ${title} para o cliente ${item.name}, acrescentando o item ${promotionalItemName} com desconto de ${discount}%. As regras são: ${rules} `
              : `Você está prestes a resgatar a promoção ${title} para o cliente ${item.name}, acrescentando o item ${promotionalItemName} por R$ ${discount || 0}. As regras são: ${rules} `)
          : (currentPromotion.isPercentage 
              ? `Você está prestes a resgatar a promoção ${title} para o cliente ${item.name} concedendo um desconto de ${discount}%. As regras são: ${rules} `
              : `Você está prestes a resgatar a promoção ${title} para o cliente ${item.name} concedendo um desconto de ${discount} reais. As regras são: ${rules} `);
        
        setTextPromotion(promoMsg);
        benefitedClientObj.benefitUsed.push({
          date: item.dateTime,
          nomeDaPromocao: title,
          discount: currentPromotion.discount,
          listaDeProdutos: item.request.map((req) => req.name),
        });
        // setSelectedPromotion(''); // REMOVIDO: Limpar apenas após confirmar no modal
        setBenefitedClientEdited(benefitedClientObj); //Guarda o objeto para ser enviado de forma global
        setOperation('add'); // Define a operação como adição
      }
      return;
    } else if (benefitedClientFinded) {
      // Se o cliente foi beneficiado
      if (reusable === 'false') {
        // Se a promoção não é reutilizável
        const promotionFinded = benefitedClientFinded.promotionTitle.find(
          (item) => item === title,
        );
        if (promotionFinded) {
          setAddPromotion(false);
          setMessagePromotionPopup(true);

          const purchasedProducts =
            benefitedClientFinded.benefitUsed.find(
              (item) => item.nomeDaPromocao === title,
            )?.listaDeProdutos || [];

          // setSelectedPromotion(''); // REMOVIDO
          setTextPromotion(
            `O cliente ${item.name || benefitedClientFinded.name
            } já usou a promoção ${title} na data ${item.dateTime
            } na compra dos itens ${purchasedProducts
              .map((item) => item)
              .join(', ')}`,
          );
          return;
        } else {
          redeemingBenefits(benefitedClientFinded, item, currentPromotion);
          return;
        }
      }
      redeemingBenefits(benefitedClientFinded, item, currentPromotion);
      return;
    }
  };

  const redeemingBenefits = (benefitedClientFinded, item, currentPromotion) => {
    if (item.name) {
      benefitedClientFinded.name = item.name;
    }
    const clientName = item.name || benefitedClientFinded.name;

    if (currentPromotion.minimumValue) {
      acumulativePurchase(item, benefitedClientFinded, currentPromotion);
      return;
    }
    setAddPromotion(true); // Habilita o botão de continuar

    benefitedClientFinded.benefitUsed.push({
      date: item.dateTime,
      nomeDaPromocao: currentPromotion.title,
      discount: currentPromotion.discount,
      listaDeProdutos: item.request.map((req) => req.name),
    });

    const promoMsg = currentPromotion.promotionalItemId 
      ? (currentPromotion.isPercentage 
          ? `Você está prestes a resgatar a promoção ${currentPromotion.title} para o cliente ${clientName}, acrescentando o item ${currentPromotion.promotionalItemName} com desconto de ${currentPromotion.discount}%. As regras são: ${currentPromotion.rules} `
          : `Você está prestes a resgatar a promoção ${currentPromotion.title} para o cliente ${clientName}, acrescentando o item ${currentPromotion.promotionalItemName} por R$ ${currentPromotion.discount || 0}. As regras são: ${currentPromotion.rules} `)
      : (currentPromotion.isPercentage 
          ? `Você está prestes a resgatar a promoção ${currentPromotion.title} para o cliente ${clientName}, concedendo um desconto de ${currentPromotion.discount}%. As regras são: ${currentPromotion.rules} `
          : `Você está prestes a resgatar a promoção ${currentPromotion.title} para o cliente ${clientName}, concedendo um desconto de ${currentPromotion.discount} reais. As regras são: ${currentPromotion.rules} `);
    
    setTextPromotion(promoMsg);
    setCurrentDiscount(currentPromotion.discount);
    setMessagePromotionPopup(true);
    // setSelectedPromotion(''); // REMOVIDO
    setOperation('edit');
    setBenefitedClientEdited(benefitedClientFinded);
    if (currentPromotion.minimumValue) {
      // If the client has a minimum value to use the promotion
      benefitedClientFinded.score += Number(item.finalPriceRequest); //
      acumulativePurchase(item, benefitedClientFinded, currentPromotion);
    }
  };

  const addEditBenefitedClient = async () => {
    const selectedPromo = promotions[activePromoIndex];
    
    if (operation === 'add') {
      let finalPriceRequest = Number(currentRequest.finalPriceRequest);
      
      if (selectedPromo?.promotionalItemId) {
        // Lógica para Adicionar Item Promocional
        try {
          const itemPromo = await getOneItemColleciton('item', selectedPromo.promotionalItemId);
          if (!currentRequest.request) currentRequest.request = [];
          
          // Define o próximo índice disponível
          const nextIndex = currentRequest.request.length > 0 
            ? Math.max(...currentRequest.request.map(r => r.indexInRequest ?? 0)) + 1 
            : 0;

          const originalPrice = Number(itemPromo.price || 0);
          const finalItemPrice = selectedPromo.isPercentage 
            ? Math.floor(originalPrice * (1 - Number(selectedPromo.discount || 0) / 100))
            : Number(selectedPromo.discount || 0);

          const newPromoItem = {
            ...itemPromo,
            price: finalItemPrice,
            promotional: true,
            entregue: false,
            deliveredByWaiter: false,
            indexInRequest: nextIndex
          };
          
          currentRequest.request.push(newPromoItem);
          finalPriceRequest += Number(newPromoItem.price);
        } catch (error) {
          console.error("Erro ao adicionar item promocional", error);
        }
      } else {
        // Lógica de Desconto Global
        if (selectedPromo?.isPercentage) {
          finalPriceRequest = Math.floor(finalPriceRequest * (1 - Number(selectedPromo.discount || 0) / 100));
        } else {
          finalPriceRequest -= Number(selectedPromo.discount || 0);
        }
      }

      currentRequest.finalPriceRequest = finalPriceRequest < 0 ? 0 : finalPriceRequest;
      if (benefitedClientEdited.score) {
        benefitedClientEdited.score = 0.1;
      }
      if (
        Array.isArray(benefitedClientEdited.benefitUsed) &&
        benefitedClientEdited.benefitUsed.length > 0 &&
        Array.isArray(benefitedClientEdited.promotionTitle) &&
        !benefitedClientEdited.promotionTitle.includes(
          benefitedClientEdited.benefitUsed[
            benefitedClientEdited.benefitUsed.length - 1
          ]?.nomeDaPromocao,
        )
      ) {
        benefitedClientEdited.promotionTitle.push(
          benefitedClientEdited.benefitUsed[
            benefitedClientEdited.benefitUsed.length - 1
          ]?.nomeDaPromocao,
        );
      }
      // Marca que o pedido já recebeu promoção
      currentRequest.hasAppliedPromotion = true;
      currentRequest.appliedPromotion = selectedPromo?.title || 'Promoção';

      //add the promotion title to the list of promotions used by the client
      setDoc(doc(db, 'requests', currentRequest.id), currentRequest);
      const docRef = await addDoc(
        collection(db, 'BenefitedCustomer'),
        benefitedClientEdited,
      );
      console.log('Document written with ID: ', docRef.id);
    } else if (operation === 'edit') {
      let finalPriceRequest = Number(currentRequest.finalPriceRequest);

      if (selectedPromo?.promotionalItemId) {
        // Lógica para Adicionar Item Promocional
        try {
          const itemPromo = await getOneItemColleciton('item', selectedPromo.promotionalItemId);
          if (!currentRequest.request) currentRequest.request = [];
          
          const nextIndex = currentRequest.request.length > 0 
            ? Math.max(...currentRequest.request.map(r => r.indexInRequest ?? 0)) + 1 
            : 0;

          const originalPrice = Number(itemPromo.price || 0);
          const finalItemPrice = selectedPromo.isPercentage 
            ? Math.floor(originalPrice * (1 - Number(selectedPromo.discount || 0) / 100))
            : Number(selectedPromo.discount || 0);

          const newPromoItem = {
            ...itemPromo,
            price: finalItemPrice,
            promotional: true,
            entregue: false,
            deliveredByWaiter: false,
            indexInRequest: nextIndex
          };
          
          currentRequest.request.push(newPromoItem);
          finalPriceRequest += Number(newPromoItem.price);
        } catch (error) {
          console.error("Erro ao adicionar item promocional", error);
        }
      } else {
        // Lógica de Desconto Global
        if (selectedPromo?.isPercentage) {
          finalPriceRequest = Math.floor(finalPriceRequest * (1 - Number(selectedPromo.discount || 0) / 100));
        } else {
          finalPriceRequest -= Number(selectedPromo.discount || 0);
        }
      }

      currentRequest.finalPriceRequest = finalPriceRequest < 0 ? 0 : finalPriceRequest;

      if (benefitedClientEdited.score) {
        benefitedClientEdited.score = 0.1;
      }
      if (
        Array.isArray(benefitedClientEdited.benefitUsed) &&
        benefitedClientEdited.benefitUsed.length > 0 &&
        Array.isArray(benefitedClientEdited.promotionTitle) &&
        !benefitedClientEdited.promotionTitle.includes(
          benefitedClientEdited.benefitUsed[
            benefitedClientEdited.benefitUsed.length - 1
          ]?.nomeDaPromocao,
        )
      ) {
        benefitedClientEdited.promotionTitle.push(
          benefitedClientEdited.benefitUsed[
            benefitedClientEdited.benefitUsed.length - 1
          ]?.nomeDaPromocao,
        );
      }

      // Marca que o pedido já recebeu promoção
      currentRequest.hasAppliedPromotion = true;
      currentRequest.appliedPromotion = selectedPromo?.title || 'Promoção';

      const NoEmpty = cleanObject(benefitedClientEdited);
      setBenefitedClientEdited(NoEmpty);
      setDoc(doc(db, 'requests', currentRequest.id), currentRequest);
      const docRef = doc(db, 'BenefitedCustomer', benefitedClientEdited.id);
      await updateDoc(docRef, benefitedClientEdited);
      console.log('Document updated with ID: ', benefitedClientEdited.id);
    }
    
    // NOVO: Limpar e fechar ao final da operação
    setSelectedPromotion('');
    setMessagePromotionPopup(false);
  };

  const acumulativePurchase = (item, benefitedClientObj, currentPromotion) => {
    const { finalPriceRequest } = item;
    const { minimumValue } = currentPromotion;

    if (benefitedClientObj.score) {
      //if the client has a score means he already bought something
      benefitedClientObj.score += Number(item.finalPriceRequest);
      if (benefitedClientObj.score >= currentPromotion.minimumValue) {
        //benefitedClientObj.score = 0.1;
        setMessagePromotionPopup(true);
        setAddPromotion(true);
        const promoMsg = currentPromotion.promotionalItemId 
          ? (currentPromotion.isPercentage 
              ? `Você está prestes a resgatar a promoção ${currentPromotion.title} para o cliente ${item.name}, acrescentando o item ${currentPromotion.promotionalItemName} com desconto de ${currentPromotion.discount}%. As regras são: ${currentPromotion.rules} `
              : `Você está prestes a resgatar a promoção ${currentPromotion.title} para o cliente ${item.name}, acrescentando o item ${currentPromotion.promotionalItemName} por R$ ${currentPromotion.discount || 0}. As regras são: ${currentPromotion.rules} `)
          : (currentPromotion.isPercentage 
              ? `Você está prestes a resgatar a promoção ${currentPromotion.title} para o cliente ${item.name}, concedendo um desconto de ${currentPromotion.discount}%. As regras são: ${currentPromotion.rules} `
              : `Você está prestes a resgatar a promoção ${currentPromotion.title} para o cliente ${item.name}, concedendo um desconto de ${currentPromotion.discount} reais. As regras são: ${currentPromotion.rules} `);
        
        setTextPromotion(promoMsg);
        benefitedClientObj.benefitUsed.push({
          date: item.dateTime,
          nomeDaPromocao: currentPromotion.title,
          discount: currentPromotion.discount,
          listaDeProdutos: item.request.map((req) => req.name),
        });
        // setSelectedPromotion(''); // REMOVIDO
        setCurrentDiscount(currentPromotion.discount);
        setOperation('edit');
        setBenefitedClientEdited(benefitedClientObj);
        return;
      }
      setMessagePromotionPopup(true);
      //benefitedClientObj.score += Number(finalPriceRequest);
      benefitedClientObj.benefitUsed.push({
        date: item.dateTime,
        nomeDaPromocao: currentPromotion.title,
        discount: currentPromotion.discount,
        listaDeProdutos: item.request.map((req) => req.name),
      });
      setBenefitedClientEdited(benefitedClientObj);
      setTextPromotion(
        `O cliente ${item.name
        } ainda não alcançou o valor mínimo para resgatar esse desconto. O valor atual acumulado pelo cliente referente a essa  promoção é de  ${benefitedClientObj.score
        } e o valor mínimo necessário é de ${currentPromotion.minimumValue
        } reais. Ele ainda deve consumir o valor de ${currentPromotion.minimumValue - benefitedClientObj.score
        }. As regras são:${currentPromotion.rules} `,
      );
      setAddPromotion(false);
      // setSelectedPromotion(''); // REMOVIDO
      if (benefitedClientObj.benefitUsed.length === 1) {
        addBenefitedClientWithNoDescount(benefitedClientObj, 'add');
      } else {
        addBenefitedClientWithNoDescount(benefitedClientObj, 'edit');
      }
      return;
    }

    if (finalPriceRequest >= minimumValue) {
      benefitedClientObj.benefitUsed.push({
        date: item.dateTime,
        nomeDaPromocao: currentPromotion.title,
        discount: currentPromotion.discount,
        listaDeProdutos: item.request.map((req) => req.name),
      });
      //benefitedClientObj.score = 0.1;
      setMessagePromotionPopup(true);
      setAddPromotion(true);
      const promoMsg = currentPromotion.promotionalItemId 
        ? (currentPromotion.isPercentage 
            ? `Você está prestes a resgatar a promoção ${currentPromotion.title} para o cliente ${item.name}, acrescentando o item ${currentPromotion.promotionalItemName} com desconto de ${currentPromotion.discount}%. As regras são: ${currentPromotion.rules} `
            : `Você está prestes a resgatar a promoção ${currentPromotion.title} para o cliente ${item.name}, acrescentando o item ${currentPromotion.promotionalItemName} por R$ ${currentPromotion.discount || 0}. As regras são: ${currentPromotion.rules} `)
        : (currentPromotion.isPercentage 
            ? `Você está prestes a resgatar a promoção ${currentPromotion.title} para o cliente ${item.name}, concedendo um desconto de ${currentPromotion.discount}%. As regras são: ${currentPromotion.rules} `
            : `Você está prestes a resgatar a promoção ${currentPromotion.title} para o cliente ${item.name}, concedendo um desconto de ${currentPromotion.discount} reais. As regras são: ${currentPromotion.rules} `);
      
      setTextPromotion(promoMsg);
      setOperation('add');
      setBenefitedClientEdited(benefitedClientObj);
    } else {
      benefitedClientObj.benefitUsed.push({
        date: item.dateTime,
        nomeDaPromocao: currentPromotion.title,
        discount: currentPromotion.discount,
        listaDeProdutos: item.request.map((req) => req.name),
      });

      setMessagePromotionPopup(true);
      benefitedClientObj.score = Number(finalPriceRequest);

      setBenefitedClientEdited(benefitedClientObj);
      setTextPromotion(
        `O cliente ${item.name
        } ainda não alcançou o valor mínimo para resgatar esse desconto. O valor atual acumulado pelo cliente referente a essa  promoção é de  ${item.finalPriceRequest
        } e o valor mínimo necessário é de ${currentPromotion.minimumValue
        } reais. Ele ainda deve consumir o valor de ${currentPromotion.minimumValue - finalPriceRequest
        }. As regras são:${currentPromotion.rules} `,
      );
      setAddPromotion(false);

      console.log(benefitedClientObj);
      if (benefitedClientObj.benefitUsed.length === 1) {
        addBenefitedClientWithNoDescount(benefitedClientObj, 'add');
      } else {
        addBenefitedClientWithNoDescount(benefitedClientObj, 'edit');
      }
      // setOperation('add');

      return;
    }
  };

  const addBenefitedClientWithNoDescount = async (
    benefitedClientObj,
    action,
  ) => {
    //add the client to the benefited list without discount, cause he didn't reach the minimum value
    //

    if (action === 'edit') {
      const docRef = doc(db, 'BenefitedCustomer', benefitedClientObj.id);
      await updateDoc(docRef, benefitedClientObj);
      console.log('Document updated with ID: ', benefitedClientObj.id);
      fetchData();
      fetchUserRequests();
      return;
    }
    if (action === 'add') {
      const docRef = await addDoc(
        collection(db, 'BenefitedCustomer'),
        benefitedClientObj,
      );
      console.log('Document written with ID: ', docRef.id);
      fetchData();
      fetchUserRequests();
    }
  };

  const orderDelivery = async (item) => {
    try {
      // 1. Marcar como entregue IMEDIATAMENTE no Firestore para sumir da tela ativa
      const requestRef = doc(db, 'requests', item.id);
      await updateDoc(requestRef, { 
        orderDelivered: true,
        done: false // Garantir que está como "Feito" ao finalizar para sumir corretamente do 'Em preparo' se houver lag
      });

      console.log('Document marked as delivered. UI should update via listener.');

      // 2. Limpar carrinho do usuário se for anônimo ou resetar se for fixo
      try {
        if (item.name === 'anonimo' || item.name === 'anonymous') {
          if (item.idUser) {
            const userRef = doc(db, 'user', item.idUser);
            const userSnap = await getDoc(userRef);
            if (userSnap.exists()) {
              await deleteData('user', item.idUser);
            }
          }
        } else if (item.idUser) {
          const userRef = doc(db, 'user', item.idUser);
          const userSnap = await getDoc(userRef);
          if (userSnap.exists()) {
            await updateDoc(userRef, { request: [] });
          } else {
            console.warn(`[WARNING] Documento de usuário ${item.idUser} não existe, pulando limpeza.`);
          }
        }
      } catch (userError) {
        console.error('Erro ao limpar carrinho do usuário (não bloqueante):', userError);
      }

      // 3. Atualizar estoque (processo mais pesado) - Apenas se o pacote for completo
      if (global.hasRawMaterial) {
        await updateIngredientsStock(item);
        await registerDailyStockMovement('Venda (Baixa Automática)');
        console.log('Stock updated successfully!');
      } else {
        console.log('Stock update skipped (Basic Package)');
      }
      // fetchUserRequests(); // Removido: o listener de tempo real já cuida da atualização da lista
    } catch (error) {
      console.error('Erro ao finalizar pedido:', error);
      alert('Houve um erro ao finalizar o pedido, mas os dados básicos foram salvos.');
    }
  };

  const openPrintScreen = (item) => {
    global.setUserNewRequest(item);
    navigate('/print');
  };

  const handleEditOrder = async (item) => {
    if (global.orderBeingEdited) {
      alert('Já existe um pedido sendo editado. Finalize ou cancele a edição anterior para editar outro pedido.');
      return;
    }

    try {
      global.setOrderBeingEdited({
        id: item.id,
        countRequest: item.countRequest,
        dateTime: item.dateTime,
        discount: item.discount || 0,
        tableNumber: item.tableNumber || null
      });

      localStorage.setItem(
        'userMenu',
        JSON.stringify({ id: item.idUser, name: item.name })
      );

      if (item.tableNumber) {
        localStorage.setItem('tableNumber', item.tableNumber);
      } else {
        localStorage.removeItem('tableNumber');
      }

      // Aqui o problema reportado: o 'item.request' que vem da base já contém o pedido exato que queremos editar.
      // E ao adicionar a array 'request' do 'user' novamente por cima do 'item.request', as informações dobram.
      // A solução é recarregar no user.request APENAS os itens da requisição atual que está sendo editada.
      // E garantimos que as flags que o cliente usa para habilitar botões (sentToKitchen) estejam presentes.

      const cleanArray = item.request && item.request.length > 0
        ? item.request.map((r, idx) => ({
          ...cleanObject(r),
          sentToKitchen: true,
          parentRequestId: item.id,
          indexInRequest: r.indexInRequest !== undefined ? r.indexInRequest : idx,
          status: r.entregue ? 'Pronto' : (r.status || '')
        }))
        : [];

      if (item.idUser) {
        const userDocRef = doc(db, 'user', item.idUser);
        const userDocSnap = await getDoc(userDocRef);
        if (userDocSnap.exists()) {
          await updateDoc(userDocRef, {
            request: cleanArray,
          });
        } else {
          await setDoc(userDocRef, {
            name: item.name || 'anonimo',
            phone: '777',
            birthday: '77',
            email: 'anonimo@anonimo.com',
            request: cleanArray
          });
        }
      }

      global.setPdvRequest(true);

      // Transição automática para o Menu em modo mobile
      if (window.innerWidth < 1000) {
        global.setPdvMobileView('menu');
      }
    } catch (error) {
      console.error('Error starting order edit:', error);
      alert('Houve um erro ao tentar editar o pedido. Tente novamente.');
      global.setOrderBeingEdited(null);
    }
  };

  const handleReleaseEditFromList = async () => {
    global.setOrderBeingEdited(null);
    global.setPdvRequest(false);
    if (localStorage.getItem('pdv') === 'true') {
      localStorage.removeItem('tableNumber');
      try {
        const anonUser = await getAnonymousUser();
        if (anonUser && anonUser.id) {
          localStorage.setItem('userMenu', JSON.stringify({ id: anonUser.id, name: 'anonimo' }));
        }
      } catch (e) {}
    }
  };

  const handleFinishEditFromList = async (orderItem) => {
    try {
      const orderRef = doc(db, 'requests', orderItem.id);
      const docSnap = await getDoc(orderRef);
      if (docSnap.exists()) {
        const data = docSnap.data();
        const items = data.request || [];
        const nowStr = `${new Date().toLocaleDateString('pt-BR')} ${new Date().toLocaleTimeString('pt-BR')}`;
        const updatedItems = items.map((it, idx) => ({
          ...it,
          sentToKitchen: true,
          sentToKitchenTime: it.sentToKitchenTime || nowStr,
          parentRequestId: orderItem.id,
          indexInRequest: it.indexInRequest !== undefined ? it.indexInRequest : idx
        }));

        await updateDoc(orderRef, cleanObject({
          request: updatedItems,
          done: true
        }));

        if (data.idUser && (data.tableNumber || orderItem.tableNumber)) {
          const userRef = doc(db, 'user', data.idUser);
          const uSnap = await getDoc(userRef);
          if (uSnap.exists()) {
            await updateDoc(userRef, { request: updatedItems });
          }
        }
      }
    } catch (e) {
      console.error('Erro ao finalizar edição pela lista:', e);
    } finally {
      await handleReleaseEditFromList();
    }
  };

  const handleRequestItemCancellation = async (order, itemIndex) => {
    if (!canCancelOrders) {
      alert('Você não tem permissão para cancelar itens do pedido. Consulte o gerente.');
      return;
    }
    const dish = order.request[itemIndex];
    
    // Determina se o pedido já está na cozinha (se tem mesa ou se já foi pago)
    const isInKitchen = order.tableNumber || order.mesa || order.paymentDone;

    if (!isInKitchen) {
      // Fluxo PRÉ-PAGO e ainda não pago -> Item NÃO está na cozinha.
      // Podemos cancelar diretamente no PDV.
      const isConfirmed = window.confirm(`Deseja cancelar o item "${dish.name}"?`);
      if (!isConfirmed) return;

      try {
        const orderRef = doc(db, 'requests', order.id);
        const itemPrice = Number(dish.finalPrice) || 0;

        // Remove do array de itens do pedido
        const updatedRequest = [...order.request];
        const arrayIndexToRemove = updatedRequest.findIndex(i => i.indexInRequest === itemIndex);
        if (arrayIndexToRemove !== -1) {
          updatedRequest.splice(arrayIndexToRemove, 1);
        }

        // Atualiza o valor total do pedido
        const newTotal = Math.max(0, (Number(order.finalPriceRequest) || 0) - itemPrice);

        await updateDoc(orderRef, {
          request: updatedRequest,
          finalPriceRequest: newTotal
        });

        // Sincroniza a remoção com o documento do usuário (carrinho/histórico ativo)
        if (order.idUser) {
          const userRef = doc(db, 'user', order.idUser);
          const userSnap = await getDoc(userRef);
          if (userSnap.exists()) {
            const userData = userSnap.data();
            if (userData.request && Array.isArray(userData.request)) {
              // Remove o item que corresponde a esta requisição e índice
              const updatedUserRequest = userData.request.filter(
                (userItem) => !(userItem.parentRequestId === order.id && userItem.indexInRequest === itemIndex)
              );
              await updateDoc(userRef, { request: updatedUserRequest });
            }
          }
        }
        alert('Item cancelado com sucesso.');
      } catch (err) {
        console.error('Erro ao cancelar item:', err);
        alert('Erro ao cancelar item. Tente novamente.');
      }
    } else {
      // Fluxo PÓS-PAGO ou já PAGO -> Item ESTÁ (ou esteve) na cozinha.
      // Solicita confirmação do cancelamento para a cozinha.
      const isConfirmed = window.confirm(`Deseja solicitar o cancelamento do item "${dish.name}" para a cozinha?`);
      if (!isConfirmed) return;

      try {
        const orderRef = doc(db, 'requests', order.id);
        const updatedRequest = [...order.request];
        updatedRequest[itemIndex] = { ...dish, cancelRequested: true };

        await updateDoc(orderRef, {
          request: updatedRequest
        });
        alert('Solicitação de cancelamento enviada para a cozinha.');
      } catch (err) {
        console.error('Erro ao solicitar cancelamento:', err);
        alert('Erro ao solicitar cancelamento. Tente novamente.');
      }
    }
  };

  const handleDishRefusalSubmit = async ({ dish, order, itemIndex, refusalType, refusalReason }) => {
    try {
      const orderRef = doc(db, 'requests', order.id);
      const updatedRequest = [...order.request];
      
      const targetIndex = updatedRequest.findIndex((r, idx) => 
        (r.indexInRequest !== undefined && r.indexInRequest === itemIndex) || idx === itemIndex
      );

      if (targetIndex === -1) {
        alert('Prato não encontrado no pedido.');
        return;
      }

      const currentDish = updatedRequest[targetIndex];
      const statusLabel = refusalType === 'ajuste' ? 'Em ajuste' : 'Prato recusado';

      updatedRequest[targetIndex] = {
        ...currentDish,
        refusalRequested: true,
        refusalType,
        refusalReason,
        refusalTimestamp: Date.now(),
        status: statusLabel,
      };

      await updateDoc(orderRef, {
        request: updatedRequest,
      });

      // Sincroniza com a coleção 'user' caso exista idUser
      if (order.idUser) {
        try {
          const userDocRef = doc(db, 'user', order.idUser);
          const userDocSnap = await getDoc(userDocRef);
          if (userDocSnap.exists()) {
            const userData = userDocSnap.data();
            if (userData.request && Array.isArray(userData.request)) {
              const newUserDataRequests = userData.request.map((uReq) => {
                const isParentMatch = !uReq.parentRequestId || uReq.parentRequestId === order.id;
                if (isParentMatch) {
                  const match = (uReq.indexInRequest !== undefined && uReq.indexInRequest === itemIndex) ||
                    (uReq.name === currentDish.name && uReq.entregue);
                  if (match) {
                    return {
                      ...uReq,
                      refusalRequested: true,
                      refusalType,
                      refusalReason,
                      refusalTimestamp: Date.now(),
                      status: statusLabel,
                    };
                  }
                }
                return uReq;
              });
              await updateDoc(userDocRef, { request: newUserDataRequests });
            }
          }
        } catch (userErr) {
          console.warn('Erro ao sincronizar recusa no documento user:', userErr);
        }
      }

      setRefusalModalData(null);
      alert(`Solicitação de ${refusalType === 'ajuste' ? 'ajuste' : 'recusa'} enviada para a cozinha com sucesso!`);
    } catch (err) {
      console.error('Erro ao enviar recusa de prato:', err);
      alert('Erro ao registrar recusa de prato. Tente novamente.');
    }
  };

  const toggleRequest = (id) => {
    const isCurrentlyOpen = Boolean(openRequests[id]);
    const order = requestsDoneList.find((r) => r.id === id);
    const hasActiveCall = Boolean(order?.waiterCall && order.waiterCall.active === true);
    const hasActivePaymentCall = Boolean(order?.paymentCall && order.paymentCall.active === true);

    if (!isCurrentlyOpen) {
      // Garçom está expandindo o pedido para verificar o que aconteceu
      if (hasActiveCall) {
        inspectedCallsRef.current.add(id);
        setInspectedCalls((prev) => new Set(prev).add(id));
      }
      if (hasActivePaymentCall) {
        inspectedPaymentCallsRef.current.add(id);
        setInspectedPaymentCalls((prev) => new Set(prev).add(id));
      }
    } else {
      // Garçom está recolhendo (fechando) o pedido após tê-lo inspecionado
      if (hasActiveCall && (inspectedCallsRef.current.has(id) || inspectedCalls.has(id))) {
        dismissWaiterCall(id);
      }
      if (hasActivePaymentCall && (inspectedPaymentCallsRef.current.has(id) || inspectedPaymentCalls.has(id))) {
        dismissPaymentCall(id);
      }
    }

    setOpenRequests((prev) => ({
      ...prev,
      [id]: !prev[id],
    }));
  };

  return (
    <div>
      {/* OVERLAY EXCLUSIVO DOS CHAMADOS DE GARÇOM E PAGAMENTO - CENTRALIZADO E COM FUNDO ESCURO */}
      {(warningsEnabled && (pendingWaiterCalls.length > 0 || pendingPaymentCalls.length > 0)) && createPortal(
        <div style={{
          position: 'fixed',
          top: 0,
          left: 0,
          width: '100vw',
          height: '100vh',
          backgroundColor: 'rgba(0,0,0,0.7)',
          zIndex: 9999,
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          flexDirection: 'column',
          gap: '15px',
          padding: '20px'
        }}>
          {/* Chamados de Mesa */}
          {pendingWaiterCalls.map((callReq) => (
            <div key={callReq.id} style={{
              backgroundColor: '#f44336',
              color: 'white',
              padding: '25px 30px',
              borderRadius: '8px',
              boxShadow: '0 8px 16px rgba(0,0,0,0.5)',
              display: 'flex',
              flexDirection: 'column',
              width: '100%',
              maxWidth: '400px',
              textAlign: 'center'
            }}>
              <h3 style={{ margin: '0 0 15px 0', fontSize: '1.5rem' }}>⚠️ Chamado de Mesa</h3>
              <p style={{ margin: '0 0 20px 0', fontSize: '1.2rem' }}>
                O cliente <strong>{callReq.waiterCall?.callerName}</strong> da mesa <strong>{callReq.waiterCall?.tableNumber}</strong> pede a presença do responsável.
              </p>
              <button
                onClick={async () => {
                  try {
                    setPendingWaiterCalls(prev => prev.filter(p => p.id !== callReq.id));
                    const docSnap = await getDoc(doc(db, 'requests', callReq.id));
                    if (docSnap.exists() && docSnap.data().waiterCall?.active === true) {
                      // Marca popup como dispensado, mas mantém active: true para continuar piscando na tela até abrir e fechar o pedido
                      await updateDoc(doc(db, 'requests', callReq.id), {
                        'waiterCall.popupDismissed': true
                      });
                    }
                  } catch (e) { console.error('Error fechar chamado', e) }
                }}
                style={{
                  backgroundColor: 'white',
                  color: '#f44336',
                  border: 'none',
                  padding: '12px',
                  borderRadius: '4px',
                  fontWeight: 'bold',
                  fontSize: '1.1rem',
                  cursor: 'pointer'
                }}
              >
                OK
              </button>
            </div>
          ))}

          {/* Chamados de PAGAMENTO */}
          {pendingPaymentCalls.map((payReq) => (
            <div key={payReq.id} style={{
              backgroundColor: '#ff9800', // Cor laranja para pagamento
              color: 'white',
              padding: '25px 30px',
              borderRadius: '8px',
              boxShadow: '0 8px 16px rgba(0,0,0,0.5)',
              display: 'flex',
              flexDirection: 'column',
              width: '100%',
              maxWidth: '400px',
              textAlign: 'center'
            }}>
              <h3 style={{ margin: '0 0 15px 0', fontSize: '1.5rem' }}>💰 Solicitação de Pagamento</h3>
              <p style={{ margin: '0 0 20px 0', fontSize: '1.2rem' }}>
                Dirija-se a mesa <strong>{payReq.paymentCall?.tableNumber}</strong> para finalizar o pagamento.
              </p>
              <button
                onClick={async () => {
                  try {
                    setPendingPaymentCalls(prev => prev.filter(p => p.id !== payReq.id));
                    const docSnap = await getDoc(doc(db, 'requests', payReq.id));
                    if (docSnap.exists() && docSnap.data().paymentCall?.active === true) {
                      await updateDoc(doc(db, 'requests', payReq.id), {
                        'paymentCall.active': false
                      });
                    }
                  } catch (e) { console.error('Error fechar chamado pagamento', e) }
                }}
                style={{
                  backgroundColor: 'white',
                  color: '#ff9800',
                  border: 'none',
                  padding: '12px',
                  borderRadius: '4px',
                  fontWeight: 'bold',
                  fontSize: '1.1rem',
                  cursor: 'pointer'
                }}
              >
                OK
              </button>
            </div>
          ))}
        </div>,
        document.body
      )}

      <Link to="/admin/admin">
        <Title mainTitle={title} />
      </Link>
      <div className={style.updateMenuMessageWrapper}>
        {loadingAvailableMenuDishes && <UpdateMenuMessage />}
      </div>
      <div className={style.warningToggleWrapper}>
        <label
          className={style.warningToggleLabel}
          title="Receber popups na tela de chamados de garçom e solicitações de conta"
        >
          <input
            type="checkbox"
            checked={warningsEnabled}
            onChange={(e) => handleToggleWarnings(e.target.checked)}
            data-testid="warning-toggle-checkbox"
          />
          <span>Receber avisos de chamados</span>
        </label>
      </div>
      {showFinalizarMessage && (
        <DefaultComumMessage
          msg="Você tem certeza que deseja finalizar este pedido?"
          onClose={closeFinalizarModal}
          onConfirm={() => confirmFinalizarPedido()}
        />
      )}
      {showPaymentBlockedPopup && (
        <DefaultComumMessage
          msg="O cliente ainda não pediu a conta, quer prosseguir mesmo assim?"
          onConfirm={() => {
            setShowPaymentBlockedPopup(false);
            setSelectedItemToPay(null);
          }}
          onClose={() => unlockPayment(selectedItemToPay)}
          affirmativeResponse="Entendi"
          negativeResponse="Efetuar o pagamento assim mesmo"
        />
      )}
      {(() => {
        if (!requestsDoneList || requestsDoneList.length === 0) return null;

        const getTableNumber = (order) => {
          if (order?.tableNumber !== undefined && order?.tableNumber !== null && String(order.tableNumber).trim() !== '') {
            return String(order.tableNumber).trim();
          }
          if (order?.mesa !== undefined && order?.mesa !== null && String(order.mesa).trim() !== '') {
            return String(order.mesa).trim();
          }
          return null;
        };

        const renderOrderCard = (orderItem, isGroupedTable = false) => {
          const { status, color } = getStatusAndColor(orderItem);
          const isPosPagamento = !!(orderItem.tableNumber || orderItem.mesa);
          const hasWaiterCalledAndConfirmed = orderItem.paymentCall && orderItem.paymentCall.active === false;
          const isPaymentDisabled = isPosPagamento && !hasWaiterCalledAndConfirmed;
          const tableDisplay = getTableNumber(orderItem);

          // Status de alertas e pendências visuais (não dependem do checkbox de popups)
          const isWaiterCallPending = Boolean(orderItem.waiterCall && orderItem.waiterCall.active === true);
          const isBillCallActive = Boolean(orderItem.paymentCall && orderItem.paymentCall.active === true);
          const isBillPending = Boolean(orderItem.paymentCall && (!orderItem.paymentDone || !orderItem.orderDelivered));
          const isDeliveryPending = Boolean(orderItem.request && orderItem.request.some((req) => req.pronto && !req.entregue));

          let orderBlinkClass = '';
          if (isWaiterCallPending) {
            orderBlinkClass = style.blinkingWaiterCallCard;
          } else if (isBillCallActive) {
            orderBlinkClass = style.blinkingPaymentCard;
          } else if (isDeliveryPending) {
            orderBlinkClass = style.blinkingDeliveryCard;
          }

          return (
            <div
              className={`${style.containerRequestListToBePrepared} ${orderBlinkClass}`}
              key={orderItem.id}
              style={orderBlinkClass ? {} : { border: `solid 2px ${color}` }}
            >
              <button
                onClick={() => toggleRequest(orderItem.id)}
                className={style.btnToggle}
              >
                {openRequests[orderItem.id] ? 'Recolher' : 'Expandir'}
              </button>
              {!openRequests[orderItem.id] ? (
                <div className={style.requestIdClosed}>
                  <p>Nome: <strong>{firstNameClient(orderItem.name)}</strong></p>
                  {!isGroupedTable && tableDisplay && <p>Mesa: <strong>{tableDisplay}</strong></p>}
                  {orderItem.deliveryAddress && <p style={{ color: 'var(--btn-color)', fontWeight: 'bold' }}>📍 ENTREGA</p>}
                  <p>Pedido: <strong>{orderItem.countRequest}</strong></p>
                  <p>Valor: <strong>R$ {(Number(orderItem.finalPriceRequest) || 0).toLocaleString('pt-BR', { minimumFractionDigits: 2 })}</strong></p>
                  <p>Status: <strong>{status}</strong></p>
                  {isWaiterCallPending && (
                    <span className={`${style.statusAlertBadge} ${style.waiterCall}`} title="Cliente chamou o garçom!">
                      🔔 Chamou Garçom
                    </span>
                  )}
                  {isBillPending && (
                    <span className={`${style.statusAlertBadge} ${style.payment}`} title="Cliente solicitou a conta!">
                      💰 Pediu a Conta
                    </span>
                  )}
                  {isDeliveryPending && (
                    <span className={`${style.statusAlertBadge} ${style.delivery}`} title="Prato pronto para levar à mesa!">
                      🍽️ Nova Entrega
                    </span>
                  )}
                </div>
              ) : (
                <div className={style.userContainer}>
                  <div>
                    {isWaiterCallPending && (
                      <div className={style.waiterCallAlertBanner}>
                        <p className={style.waiterCallAlertText}>
                          🔔 <strong>Cliente chamou o Garçom!</strong> Atenda a mesa. O alerta para ao recolher este pedido ou clicar ao lado.
                        </p>
                        <button
                          type="button"
                          className={style.btnDismissCall}
                          onClick={() => dismissWaiterCall(orderItem.id)}
                        >
                          ✓ Concluir Chamado
                        </button>
                      </div>
                    )}
                    {isBillCallActive && (
                      <div className={style.waiterCallAlertBanner} style={{ backgroundColor: '#fff7ed', borderColor: '#ea580c' }}>
                        <p className={style.waiterCallAlertText} style={{ color: '#9a3412' }}>
                          💰 <strong>Cliente pediu a conta!</strong> Dirija-se à mesa para receber. O alerta para ao recolher este pedido ou clicar ao lado.
                        </p>
                        <button
                          type="button"
                          className={style.btnDismissCall}
                          style={{ backgroundColor: '#ea580c', color: 'white' }}
                          onClick={() => dismissPaymentCall(orderItem.id)}
                        >
                          ✓ Concluir Chamado
                        </button>
                      </div>
                    )}
                    {!isBillCallActive && isBillPending && (
                      <div style={{
                        backgroundColor: '#fff7ed',
                        border: '2px solid #ea580c',
                        borderRadius: '8px',
                        padding: '8px 12px',
                        marginBottom: '10px',
                        textAlign: 'center',
                        fontWeight: 'bold',
                        color: '#9a3412',
                        fontSize: '0.95rem'
                      }}>
                        💰 Cliente pediu a conta nesta mesa! Receba o pagamento e finalize o pedido.
                      </div>
                    )}
                    {isDeliveryPending && (
                      <div style={{
                        backgroundColor: '#fefce8',
                        border: '2px solid #b45309',
                        borderRadius: '8px',
                        padding: '8px 12px',
                        marginBottom: '10px',
                        textAlign: 'center',
                        fontWeight: 'bold',
                        color: '#92400e',
                        fontSize: '0.95rem'
                      }}>
                        🍽️ Há prato pronto para entrega! Leve à mesa e clique em "NOVA ENTREGA".
                      </div>
                    )}
                    <div className={style.orderHeaderInfo}>
                      <div className={style.orderHeaderRow}>
                        <p>
                          <span>Nome:</span> <strong>{firstNameClient(orderItem.name)}</strong>
                        </p>
                        {!isGroupedTable && tableDisplay && (
                          <p>
                            <span>Mesa:</span> <strong>{tableDisplay}</strong>
                          </p>
                        )}
                      </div>
                      <div className={style.orderHeaderRow}>
                        <p>
                          <span>Pedido:</span> <strong>#{orderItem.countRequest}</strong>
                        </p>
                        <p>
                          <span>Data:</span> {orderItem.dateTime}
                        </p>
                      </div>
                    </div>

                    {orderItem.deliveryAddress && (
                      <div style={{ backgroundColor: '#fff3cd', padding: '10px', borderRadius: '8px', borderLeft: '5px solid #ff9800', marginTop: '10px', marginBottom: '10px' }}>
                        <h4 style={{ margin: '0 0 5px 0', color: '#d32f2f' }}>📍 Endereço de Entrega</h4>
                        <p style={{ margin: '0', fontSize: '0.9rem', lineHeight: '1.4' }}>
                          <strong>Logradouro:</strong> {orderItem.deliveryAddress.logradouro}, nº {orderItem.deliveryAddress.numero}
                        </p>
                        <p style={{ margin: '0', fontSize: '0.9rem', lineHeight: '1.4' }}>
                          <strong>Bairro:</strong> {orderItem.deliveryAddress.bairro}
                        </p>
                        {orderItem.deliveryAddress.complemento && (
                          <p style={{ margin: '0', fontSize: '0.9rem', lineHeight: '1.4' }}>
                            <strong>Complemento:</strong> {orderItem.deliveryAddress.complemento}
                          </p>
                        )}
                        <p style={{ margin: '0', fontSize: '0.9rem', lineHeight: '1.4' }}>
                          <strong>Distância Aproximada:</strong> {orderItem.deliveryAddress.distance > 0 ? `${orderItem.deliveryAddress.distance} km` : 'N/A'}
                        </p>
                        <a 
                          href={`https://www.google.com/maps/dir/?api=1&origin=${encodeURIComponent(global.establishmentCep || '')}&destination=${encodeURIComponent(orderItem.deliveryAddress.logradouro + ', ' + orderItem.deliveryAddress.numero + ', ' + orderItem.deliveryAddress.bairro + ', ' + orderItem.deliveryAddress.cep)}`} 
                          target="_blank" 
                          rel="noreferrer"
                          style={{ display: 'inline-block', marginTop: '10px', backgroundColor: '#4285F4', color: 'white', padding: '5px 10px', borderRadius: '4px', textDecoration: 'none', fontWeight: 'bold', fontSize: '0.85rem' }}
                        >
                          🗺️ Abrir Rota no Maps
                        </a>
                      </div>
                    )}
                    {orderItem.serviceChargeEnabled && (
                      <h4 style={{ textAlign: 'center', margin: '3px 0', fontSize: '0.9rem', color: 'var(--btn-color)' }}>
                        Taxa de Serviço ({orderItem.serviceChargePercent || 10}%): R${' '}
                        {(Number(orderItem.serviceChargeValue) || 0).toLocaleString('pt-BR', {
                          minimumFractionDigits: 2,
                          maximumFractionDigits: 2,
                        })}
                      </h4>
                    )}
                    <h2 style={{ margin: '4px 0' }}>
                      Valor final R${' '}
                      {(Number(orderItem.finalPriceRequest) || 0).toLocaleString('pt-BR', {
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2,
                      })}
                    </h2>
                    
                    {orderItem.customerFeedback && (
                      <div style={{ marginTop: '15px', padding: '10px', backgroundColor: '#f9f9f9', borderRadius: '8px', borderLeft: '5px solid var(--btn-color)' }}>
                        {orderItem.customerFeedback.service && (
                          <p style={{ fontSize: '0.9rem', textAlign: 'left', marginBottom: '4px' }}>
                            <span>Avaliação do serviço:</span> {orderItem.customerFeedback.service} / 5
                          </p>
                        )}
                        {orderItem.customerFeedback.product && (
                          <p style={{ fontSize: '0.9rem', textAlign: 'left', marginBottom: '4px' }}>
                            <span>Avaliação do produto:</span> {orderItem.customerFeedback.product} / 5
                          </p>
                        )}
                        {orderItem.customerFeedback.comment && (
                          <p style={{ fontSize: '0.9rem', textAlign: 'left', fontStyle: 'italic', marginTop: '8px' }}>
                            <span>Comentário:</span> "{orderItem.customerFeedback.comment}"
                          </p>
                        )}
                      </div>
                    )}
                    <div className={style.customerProfileButton}>
                      <ButtonCustomerProfile
                        item={orderItem}
                        request={orderItem.request}
                        descontFinalPrice={descontFinalPrice}
                      />
                    </div>
                    <PaymentMethod
                      item={orderItem}
                      onPaymentMethodChange={handlePaymentMethodChange}
                      isPaymentDisabled={isPaymentDisabled}
                      onPaymentBlocked={() => {
                        setSelectedItemToPay(orderItem);
                        setShowPaymentBlockedPopup(true);
                      }}
                    />
                    {global.packageTier !== 1 && (() => {
                      const isRegistered = registeredUserIds.has(orderItem.idUser);
                      const hasPromotionAlready = 
                        orderItem.hasAppliedPromotion || 
                        orderItem.appliedPromotion || 
                        (orderItem.request && orderItem.request.some(r => r.promotional));

                      if (!isRegistered) {
                        return (
                          <div className={style.promotionSelect}>
                            <select disabled value="">
                              <option value="">Cliente não registrado</option>
                            </select>
                          </div>
                        );
                      }

                      if (hasPromotionAlready) {
                        return (
                          <div className={style.promotionSelect}>
                            <select disabled value="">
                              <option value="">Promoção Aplicada</option>
                            </select>
                          </div>
                        );
                      }

                      return (
                        <div className={style.promotionSelect}>
                          <select
                            name="selectedPromotion"
                            value={selectedPromotion}
                            onChange={(e) => handleSelectChange(e, orderItem)}
                          >
                            <option value="">Promoções</option>
                            {promotions &&
                              promotions.length > 0 &&
                              promotions.map((promotion, index) => (
                                <option key={index} value={index}>
                                  {promotion.title}
                                </option>
                              ))}
                          </select>
                        </div>
                      );
                    })()}
                  </div>
                  <div className={style.btnStatus}>
                    <button
                      onClick={() => openShowModal(orderItem.id)}
                      className={style.pendent}
                      disabled={global.orderBeingEdited?.id === orderItem.id || !canCancelOrders}
                      title={!canCancelOrders ? "Apenas colaboradores com permissão podem cancelar pedidos" : "Cancelar pedido"}
                      style={!canCancelOrders ? { opacity: 0.5, cursor: 'not-allowed', filter: 'grayscale(50%)' } : {}}
                    >
                      Cancelar pedido
                    </button>

                    {localStorage.getItem('pdv') === 'true' && !orderItem.paymentDone && (
                      global.orderBeingEdited?.id === orderItem.id ? (
                        <div style={{ display: 'inline-flex', gap: '5px', flexWrap: 'wrap' }}>
                          <button
                            className={style.pendent}
                            style={{ backgroundColor: '#2e7d32', color: 'white', fontWeight: 'bold' }}
                            onClick={() => handleFinishEditFromList(orderItem)}
                            title="Finalizar edição do pedido e enviar itens"
                          >
                            Finalizar
                          </button>
                          <button
                            className={style.pendent}
                            style={{ backgroundColor: '#ff9800', color: 'white', fontWeight: 'bold' }}
                            onClick={() => {
                              global.setPdvRequest(true);
                              if (window.innerWidth < 1000) {
                                global.setPdvMobileView('menu');
                              }
                            }}
                            title="Continuar editando itens no cardápio"
                          >
                            Continuar
                          </button>
                          <button
                            className={style.pendent}
                            style={{ backgroundColor: '#757575', color: 'white' }}
                            onClick={() => handleReleaseEditFromList()}
                            title="Liberar pedido no PDV"
                          >
                            Liberar
                          </button>
                        </div>
                      ) : (
                        <button
                          className={style.pendent}
                          style={{ backgroundColor: 'orange', color: 'white' }}
                          onClick={() => handleEditOrder(orderItem)}
                        >
                          Editar Pedido
                        </button>
                      )
                    )}
                    <button
                      disabled={
                        payingOrders[orderItem.id] ||
                        global.orderBeingEdited?.id === orderItem.id ||
                        (!isPaymentDisabled && !orderItem.paymentMethod)
                      }
                      className={orderItem.paymentDone ? style.done : style.pendent}
                      onClick={(e) => {
                        if (isPaymentDisabled) {
                          e.preventDefault();
                          setSelectedItemToPay(orderItem);
                          setShowPaymentBlockedPopup(true);
                          return;
                        }
                        changeStatusPaid(orderItem);
                      }}
                      style={
                        isPaymentDisabled
                          ? { opacity: 0.5, cursor: 'not-allowed' }
                          : payingOrders[orderItem.id]
                          ? { opacity: 0.7, cursor: 'wait' }
                          : {}
                      }
                    >
                      {payingOrders[orderItem.id] ? 'Processando...' : 'Pago'}
                    </button>
                    {(() => {
                      const btnState = getPostpaidButtonState(orderItem);
                      return (
                        <button
                          disabled={orderItem.orderDelivered || global.orderBeingEdited?.id === orderItem.id || btnState.label === 'PRONTO'}
                          className={btnState.className}
                          style={btnState.inlineStyle}
                          onClick={() => handleWaiterDelivery(orderItem)}
                        >
                          {btnState.label}
                        </button>
                      );
                    })()}
                    <button
                      disabled={!orderItem.paymentDone || orderItem.orderDelivered || global.orderBeingEdited?.id === orderItem.id || !isOrderFullyFinished(orderItem)}
                      className={style.pendent}
                      onClick={() => openFinalizarModal(orderItem)}
                    >
                      Finalizar
                    </button>
                    <button
                      disabled={!orderItem.paymentMethod || global.orderBeingEdited?.id === orderItem.id}
                      className={`${style.pendent} ${style.btnFiscalAttributes}`}
                      onClick={() => openPrintScreen(orderItem)}
                    >
                      Nota
                    </button>

                    {(() => {
                      const customerUser = orderItem.idUser ? usersMap.get(orderItem.idUser) : null;
                      const availableCredit = customerUser ? parseFloat(customerUser.credit || 0) : 0;

                      if (!orderItem.paymentDone && availableCredit > 0) {
                        return (
                          <div className={style.customerCreditBox} title="Crédito disponível do cliente">
                            <span>Crédito:</span>
                            <strong>
                              R${' '}
                              {availableCredit.toLocaleString('pt-BR', {
                                minimumFractionDigits: 2,
                                maximumFractionDigits: 2,
                              })}
                            </strong>
                          </div>
                        );
                      }

                      if (orderItem.paymentDone && orderItem.creditUsed > 0) {
                        return (
                          <div className={style.customerCreditBoxPaid} title="Crédito utilizado neste pedido">
                            <span>
                              Crédito Usado: R${' '}
                              {Number(orderItem.creditUsed).toLocaleString('pt-BR', {
                                minimumFractionDigits: 2,
                                maximumFractionDigits: 2,
                              })}
                            </span>
                          </div>
                        );
                      }

                      return null;
                    })()}
                  </div>

                  {/* Modais movidos para fora da grid de botões */}
                  {ShowDefaultMessage && selectedRequestId === orderItem.id && (
                    <DefaultComumMessage
                      msg="Você está prestes a excluir esse pedido"
                      onClose={() => {
                        setShowDefaultMessage(false);
                      }}
                      onConfirm={() =>
                        handleDeleteRequest(selectedRequestId)
                      }
                    />
                  )}

                  {messagePromotionPopup && (
                    <MessagePromotions
                      message={textPromotion}
                      AddPromotion={AddPromotion}
                      setClose={setMessagePromotionPopup}
                      onContinue={addEditBenefitedClient}
                    />
                  )}
                </div>
              )}
              {orderItem.request &&
                openRequests[orderItem.id] &&
                orderItem.request.map((dish, recipeIndex) => {
                  const dishNeedsDelivery = dish.pronto && !dish.entregue;
                  return (
                    <div
                      className={`${style.requestItem} ${dishNeedsDelivery ? style.dishItemNeedsDelivery : ''}`}
                      key={recipeIndex}
                    >
                      {recipeModal.openModal && (
                        <RecipeModal
                          setRecipeModal={setRecipeModal}
                          recipeModal={recipeModal}
                        />
                      )}
                      <div>
                        <h5 style={{ textAlign: 'center', marginBottom: '8px' }}>{dish.name}</h5>
                        <div style={{ display: 'flex', justifyContent: 'center', gap: '10px', marginBottom: '5px', flexWrap: 'wrap' }}>
                          {dishNeedsDelivery && (
                            <span className={`${style.statusAlertBadge} ${style.delivery}`} style={{ fontSize: '0.75rem', padding: '2px 8px' }}>
                              🍽️ Pronto (Levar à Mesa)
                            </span>
                          )}
                          {dish.pronto && !dishNeedsDelivery && <span className={style.indicatorPronto}>Pronto</span>}
                          {dish.entregue && <span className={style.indicatorEntregue}>Entregue</span>}
                          {dish.refusalRequested && (
                            <span style={{
                              backgroundColor: dish.refusalType === 'ajuste' ? '#f59e0b' : '#ef4444',
                              color: '#fff',
                              padding: '2px 8px',
                              borderRadius: '4px',
                              fontSize: '0.8rem',
                              fontWeight: 'bold'
                            }}>
                              {dish.refusalType === 'ajuste' ? 'Em Ajuste na Cozinha' : 'Prato Recusado (Cozinha)'}
                            </span>
                          )}
                        </div>
                        {dish.entregue && dish.tempo_levado && (
                          <div style={{ textAlign: 'center', fontSize: '0.9rem', color: '#666', fontWeight: 'bold', marginBottom: '5px' }}>
                            ({dish.tempo_levado})
                          </div>
                        )}

                        {dish.category && (
                          <p className={style.category}>
                            Categoria {dish.category}
                          </p>
                        )}
                        {dish.size && (
                          <p>
                            Tamanho:<strong>{dish.size}</strong>
                          </p>
                        )}
                        <h5>Acompanhamento</h5>
                        <div className={style.sideDishesList}>
                          {dish.sideDishes && dish.sideDishes.length > 0 ? (
                            dish.sideDishes.map((side, index) => (
                              <p key={index}>{side.name},</p>
                            ))
                          ) : (
                            <p>Não tem acompanhamento</p>
                          )}
                        </div>
                      </div>
                      <div className={style.imageButton}>
                        <button
                          onClick={() =>
                            setRecipeModal({ openModal: true, id: dish.id })
                          }
                          className="btn btn-warning"
                        >
                          Receita
                        </button>
                        {dish.entregue ? (
                          <button
                            onClick={() => setRefusalModalData({
                              dish: dish,
                              order: orderItem,
                              itemIndex: dish.indexInRequest !== undefined ? dish.indexInRequest : recipeIndex
                            })}
                            className="btn btn-danger"
                            disabled={dish.refusalRequested || orderItem.paymentDone}
                            style={{
                              backgroundColor: dish.refusalRequested ? '#f59e0b' : '#dc2626',
                              borderColor: dish.refusalRequested ? '#d97706' : '#dc2626',
                              color: '#ffffff',
                              fontWeight: 'bold',
                              opacity: (dish.refusalRequested || orderItem.paymentDone) ? 0.7 : 1,
                              cursor: (dish.refusalRequested || orderItem.paymentDone) ? 'not-allowed' : 'pointer'
                            }}
                            title={dish.refusalRequested ? "Aguardando resposta da cozinha" : "Registrar recusa ou ajuste deste prato"}
                          >
                            {dish.refusalRequested ? 'Em Análise na Cozinha' : 'Prato Recusado'}
                          </button>
                        ) : (
                          <button
                            onClick={() => handleRequestItemCancellation(orderItem, dish.indexInRequest !== undefined ? dish.indexInRequest : recipeIndex)}
                            className="btn btn-danger"
                            disabled={!canCancelOrders || dish.pronto || dish.cancelRequested || orderItem.paymentDone}
                            title={!canCancelOrders ? "Apenas colaboradores com permissão podem cancelar itens" : (dish.cancelRequested ? 'Cancelamento Solicitado' : 'Cancelar Item')}
                            style={!canCancelOrders ? { opacity: 0.5, cursor: 'not-allowed', filter: 'grayscale(50%)' } : {}}
                          >
                            {dish.cancelRequested ? 'Cancelamento Solicitado' : 'Cancelar Item'}
                          </button>
                        )}
                      </div>
                    </div>
                  );
                })}
            </div>
          );
        };

        // Cálculo de status e cor para as mesas no painel superior
        const getTableStatusStyle = (ordersForTable) => {
          // 1. Azul piscando: Cliente chamando o garçom (URGENTE)
          const hasWaiterCall = ordersForTable.some(
            (o) => o.waiterCall && o.waiterCall.active === true
          );
          if (hasWaiterCall) {
            return { className: `${style.tableBlue} ${style.tableBlueBlinking}`, label: 'Chamou o garçom' };
          }

          // 2. Verde piscando: Cliente quer a conta (chamado ativo para o garçom)
          const hasActiveBillCall = ordersForTable.some(
            (o) => o.paymentCall && o.paymentCall.active === true
          );
          if (hasActiveBillCall) {
            return { className: `${style.tableGreen} ${style.tableGreenBlinking}`, label: 'Pediu a conta' };
          }

          // 2.1. Verde sólido: Garçom já atendeu o chamado, aguardando pagamento
          const hasPendingBill = ordersForTable.some(
            (o) => Boolean(o.paymentCall) && (!o.paymentDone || !o.orderDelivered)
          );
          if (hasPendingBill) {
            return { className: style.tableGreen, label: 'Conta solicitada' };
          }

          // 3. Laranja: Prato pronto para ser enviado para a mesa (pronto && !entregue)
          const hasDishReady = ordersForTable.some(
            (o) => o.request && Array.isArray(o.request) && o.request.some((req) => req.pronto && !req.entregue)
          );
          if (hasDishReady) {
            return { className: style.tableOrange, label: 'Prato pronto para entrega' };
          }

          // 3. Vermelha: Acabaram de fazer pedido / pratos em preparo (!pronto && !entregue)
          const hasPendingPrep = ordersForTable.some(
            (o) => o.request && Array.isArray(o.request) && o.request.some((req) => !req.pronto && !req.entregue)
          );
          const hasNoItemsYet = ordersForTable.some(
            (o) => !o.orderDelivered && (!o.request || o.request.length === 0)
          );
          if (hasPendingPrep || hasNoItemsYet) {
            return { className: style.tableRed, label: 'Pedido recém feito / em preparo' };
          }

          // 4. Sem preenchimento: Todos os pedidos já entregues na mesa
          return { className: style.tableDelivered, label: 'Todos os pratos entregues' };
        };

        // 1. Extrair mesas ativas (ocupadas) e pedidos pré-pagos
        const occupiedTables = [];
        const tableOrdersMap = new Map();
        const prePagoOrders = [];

        requestsDoneList.forEach((order) => {
          const table = getTableNumber(order);
          if (table) {
            if (!tableOrdersMap.has(table)) {
              tableOrdersMap.set(table, []);
              occupiedTables.push(table);
            }
            tableOrdersMap.get(table).push(order);
          } else {
            prePagoOrders.push(order);
          }
        });

        // Ordenar mesas numericamente crescente (ex: 01, 13, 15, 17...)
        occupiedTables.sort((a, b) => {
          const numA = parseInt(a, 10);
          const numB = parseInt(b, 10);
          if (!isNaN(numA) && !isNaN(numB)) {
            return numA - numB;
          }
          return String(a).localeCompare(String(b), undefined, { numeric: true });
        });

        // 2. Contar pedidos por mesa para agrupamento multi-cliente
        const tableCounts = {};
        requestsDoneList.forEach((order) => {
          const table = getTableNumber(order);
          if (table) {
            tableCounts[table] = (tableCounts[table] || 0) + 1;
          }
        });

        // 3. Construir lista de grupos e pedidos individuais
        const elements = [];
        const processedTables = new Set();

        requestsDoneList.forEach((order) => {
          const table = getTableNumber(order);
          const isMultiOrderTable = table && tableCounts[table] > 1;

          if (isMultiOrderTable) {
            if (!processedTables.has(table)) {
              processedTables.add(table);
              const tableOrders = requestsDoneList.filter(
                (o) => getTableNumber(o) === table
              );
              elements.push({
                type: 'tableGroup',
                tableNumber: table,
                orders: tableOrders,
                key: `table-group-${table}`,
              });
            }
          } else {
            elements.push({
              type: 'singleOrder',
              order,
              key: order.id,
            });
          }
        });

        // 4. Ordenar pilha de pedidos da mesa menor para a maior
        elements.sort((a, b) => {
          const tableA = a.type === 'tableGroup' ? a.tableNumber : getTableNumber(a.order);
          const tableB = b.type === 'tableGroup' ? b.tableNumber : getTableNumber(b.order);

          if (tableA && tableB) {
            const numA = parseInt(tableA, 10);
            const numB = parseInt(tableB, 10);
            if (!isNaN(numA) && !isNaN(numB)) {
              return numA - numB;
            }
            return String(tableA).localeCompare(String(tableB), undefined, { numeric: true });
          }

          // Mesas vêm antes de pedidos pré-pagos
          if (tableA && !tableB) return -1;
          if (!tableA && tableB) return 1;

          // Ambos pré-pagos: ordenar por countRequest crescente
          const countA = a.order?.countRequest || 0;
          const countB = b.order?.countRequest || 0;
          return countA - countB;
        });

        // 5. Filtrar por mesa ou pedido pré-pago selecionado
        const displayedElements = elements.filter((element) => {
          if (!selectedTableFilter) return true;

          if (selectedTableFilter.startsWith('prepago-')) {
            const prepagoId = selectedTableFilter.replace('prepago-', '');
            return element.type === 'singleOrder' && element.order?.id === prepagoId;
          }

          if (element.type === 'tableGroup') {
            return element.tableNumber === selectedTableFilter;
          }

          return getTableNumber(element.order) === selectedTableFilter;
        });

        return (
          <>
            {/* Painel Superior: Pós-pago Mesas & Pré-pago */}
            <div className={style.tablesDashboardSection}>
              {occupiedTables.length > 0 && (
                <div className={style.sectionBlock}>
                  <h3 className={style.sectionTitle}>Pós pago Mesas</h3>
                  <div className={style.tablesGrid}>
                    {occupiedTables.map((table) => {
                      const tableOrders = tableOrdersMap.get(table) || [];
                      const { className: statusClass, label: statusLabel } = getTableStatusStyle(tableOrders);
                      const isSelected = selectedTableFilter === table;
                      const displayTableNum =
                        !isNaN(parseInt(table, 10)) && parseInt(table, 10) < 10
                          ? String(table).padStart(2, '0')
                          : table;

                      return (
                        <button
                          type="button"
                          key={`table-btn-${table}`}
                          data-testid={`table-button-${table}`}
                          className={`${style.tableSquare} ${statusClass} ${isSelected ? style.tableSelected : ''}`}
                          onClick={() => setSelectedTableFilter((prev) => (prev === table ? null : table))}
                          title={`Mesa ${table} - ${statusLabel} (${tableOrders.length} pedido${tableOrders.length > 1 ? 's' : ''})`}
                          aria-pressed={isSelected}
                        >
                          {displayTableNum}
                        </button>
                      );
                    })}
                  </div>
                </div>
              )}

              {prePagoOrders.length > 0 && (
                <div className={style.sectionBlock}>
                  <h3 className={style.sectionTitle}>Pré - Pago</h3>
                  <div className={style.tablesGrid}>
                    {prePagoOrders.map((order) => {
                      const prepagoKey = `prepago-${order.id}`;
                      const isSelected = selectedTableFilter === prepagoKey;
                      const displayNum = order.countRequest ? `#${order.countRequest}` : `#${order.id.slice(-4)}`;

                      return (
                        <button
                          type="button"
                          key={prepagoKey}
                          data-testid={`prepago-button-${order.id}`}
                          className={`${style.prePagoSquare} ${isSelected ? style.tableSelected : ''}`}
                          onClick={() => setSelectedTableFilter((prev) => (prev === prepagoKey ? null : prepagoKey))}
                          title={`Pedido Pré-Pago ${displayNum} - Cliente: ${order.name || 'Cliente'}`}
                          aria-pressed={isSelected}
                        >
                          {displayNum}
                        </button>
                      );
                    })}
                  </div>
                </div>
              )}
            </div>

            {/* Barra de Filtro / Limpar Seleção */}
            {selectedTableFilter && (
              <div className={style.clearSelectionBar}>
                <span className={style.selectionInfoText}>
                  Exibindo apenas:{' '}
                  <strong>
                    {selectedTableFilter.startsWith('prepago-') ? 'Pedido Pré-Pago' : `Mesa ${selectedTableFilter}`}
                  </strong>
                </span>
                <button
                  type="button"
                  data-testid="clear-selection-btn"
                  className={style.btnClearSelection}
                  onClick={() => setSelectedTableFilter(null)}
                >
                  ✕ Limpar seleção (Ver todas as mesas)
                </button>
              </div>
            )}

            {/* Lista de Pedidos Ordenada por Mesa (menor para maior) */}
            {displayedElements.map((element) => {
              if (element.type === 'tableGroup') {
                const tableHasWaiterCall = element.orders.some((o) => o.waiterCall && o.waiterCall.active === true);
                const tableHasActiveBillCall = element.orders.some((o) => o.paymentCall && o.paymentCall.active === true);
                const tableHasPendingBill = element.orders.some((o) => o.paymentCall && (!o.paymentDone || !o.orderDelivered));
                const tableHasDelivery = element.orders.some((o) => o.request && o.request.some((r) => r.pronto && !r.entregue));

                let tableBlinkClass = '';
                if (tableHasWaiterCall) {
                  tableBlinkClass = style.blinkingWaiterCallTable;
                } else if (tableHasActiveBillCall) {
                  tableBlinkClass = style.blinkingPaymentTable;
                } else if (tableHasDelivery) {
                  tableBlinkClass = style.blinkingDeliveryTable;
                }

                return (
                  <div
                    className={`${style.tableGroupWrapper} ${tableBlinkClass}`}
                    key={element.key}
                    data-testid={`table-group-${element.tableNumber}`}
                  >
                    <div className={style.tableGroupHeader}>
                      <div className={style.tableGroupTitle}>
                        <span>Mesa: <strong>{element.tableNumber}</strong></span>
                        {tableHasWaiterCall && (
                          <span className={`${style.statusAlertBadge} ${style.waiterCall}`}>
                            🔔 Garçom Chamado
                          </span>
                        )}
                        {tableHasPendingBill && (
                          <span className={`${style.statusAlertBadge} ${style.payment}`}>
                            💰 Pediu a Conta
                          </span>
                        )}
                        {tableHasDelivery && (
                          <span className={`${style.statusAlertBadge} ${style.delivery}`}>
                            🍽️ Prato Pronto
                          </span>
                        )}
                      </div>
                      <span className={style.tableGroupBadge}>
                        {element.orders.length} pedidos nesta mesa
                      </span>
                    </div>
                    {element.orders.map((tableOrder) =>
                      renderOrderCard(tableOrder, true)
                    )}
                  </div>
                );
              }

              return renderOrderCard(element.order, false);
            })}
          </>
        );
      })()}

      {refusalModalData && (
        <DishRefusalModal
          dish={refusalModalData.dish}
          order={refusalModalData.order}
          itemIndex={refusalModalData.itemIndex}
          onClose={() => setRefusalModalData(null)}
          onSubmit={handleDishRefusalSubmit}
        />
      )}
    </div>
  );
};
export default RequestListToBePrepared;

///admin/requestlist
